import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import UploadForm from "components/shared-components/UploadForm";
import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  AUTH_STATUS_NEW,
  AUTH_STATUS_RR,
  SOURCE_QUEUE,
} from "constants/FormatDataContanst";
import { DEFAULT_NULL_NUMBER } from "constants/IssueInvoiceConstant";
import {
  FIELD_DISABLE_CONFIG,
  ISSUE_INVOICE_BUYER_FIELD,
  ISSUE_INVOICE_COMMON_FIELD,
  ISSUE_INVOICE_HHDV_FIELD,
  ISSUE_INVOICE_SELLER_FIELD,
  MODE_INVOICE_ACTION,
  TYPE_ADJUST_INVOICE,
  TYPE_INVOICE_ANOTHER,
} from "constants/WarehouseAgencyConstant";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import {
  EXTRA_BUTTON,
  formConvertErrorMessage,
  generateDateField,
  generateInputFieldArray,
  generateSelectFieldArray,
  loopGenerateField,
} from "helpers/form_helper_new";
import { useConfigInvoiceField } from "hook";
import moment from "moment";
import { formatTimestampToDate } from "pages/DataFormatInvoice/utils";
import { FIELD_CUSTOMER } from "pages/GeneralInfo/Customer/utils";
import DetailDataProduct from "pages/GeneralInfo/Product/DetailData";
import { modeDetail } from "pages/GeneralInfo/Product/utils";
import { caculateHHDVCommon } from "pages/IssueInvoice/helper/functionHelper";
import PropTypes from "prop-types";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Table,
} from "reactstrap";
import {
  adjustIssueInvoice,
  createIssueInvoice,
  createListProductInvoice,
  downloadXmlIssueInvoice,
  editIssueInvoice,
  getDetailIssueInvoice,
  getEnterpriseByTaxCode,
  getInvoiceMaxDate,
  getInvoiceMinDate,
  replaceIssueInvoice,
  resetCreateIssueInvoice,
  resetCreateProductInvoice,
  resetEditIssueInvoice,
  resetGetDetailIssueInvoice,
  resetGetEnterpriseByTaxCode,
  resetGetInvoiceMaxDate,
  resetGetInvoiceMinDate,
  resetUploadAttackFileInvoice,
  uploadAttackFileInvoice,
} from "store/actions";
import { resetCreateAccountBank } from "store/general-info/customer/actions";
import {
  CREATE_ACCOUNT_BANK_FAIL,
  CREATE_ACCOUNT_BANK_SUCCESS,
} from "store/general-info/customer/actionTypes";
import {
  CREATE_PRODUCT_INVOICE_FAIL,
  CREATE_PRODUCT_INVOICE_SUCCESS,
} from "store/general-info/product/actionTypes";
import {
  GET_INVOICE_MIN_DATE_FAIL,
  GET_INVOICE_MIN_DATE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import writeXlsxFile from "write-excel-file";
import * as yup from "yup";
import "../../IssueInvoice/detailInvoice.scss";
import CreateAccountBankModal from "../../IssueInvoice/modal/CreateAccountBankModal";
import SearchCustomerModal from "../../IssueInvoice/modal/SearchCustomerModal";
import UploadProductExcelModal from "../../IssueInvoice/modal/UploadProductExcelModal";
import {
  changeYearOfSerial,
  checkDateWhenRelease,
  checkVisibleByConditionRowData,
  COMMON_CONDITION_VISIBLE,
  convertDate,
  customViewField,
  getDecimalScaleByUnitCurrency,
  getIconFile,
  initOptionDateLocale,
  isEmptyNumber,
  issueInvoiceModeList,
  issueInvoicePageViewList,
} from "../../IssueInvoice/utils";
const DetailData = forwardRef((props, ref) => {
  const {
    isPage, // check là modal hay page mới
    isOpenModal,
    isEnterprise,
    dataDetail,
    btnShowFooter,
    dataConfirmAction,
    toggleModal,
    mode,
    pageView,
    typeInvoiceAnother,
    khhdonDefault,
    showPdfById,
    invoiceSymbolList,
    setDataInvoiceTemp,
    setDataConfirmAction,
    setPageViewByRow,
    setMode,
    isRoleStore,
    isRoleAccountant,
    setTitleBodyDenyRelease,
    toggleDenyReleaseModal,
    setTitleBodyCheckRelease,
    toggleCheckReleaseModal,
  } = props;

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuReleaseInfo, buStoreHeader, finalBuInfo } = Dashboard;

  // Delay when tìm kiếm hàng hóa change
  const [inputProductSearch, setInputProductSearch] = useState(null);
  useEffect(() => {
    if (inputProductSearch !== null) {
      const delayInputProductSearch = setTimeout(() => {
        resultAllProduct.refetch();
      }, 500);
      return () => clearTimeout(delayInputProductSearch);
    }
  }, [inputProductSearch]);

  const {
    isAllSuccess: isSuccessConfigField,
    isAllLoading: isLoadingConfigField,
    listData: [
      listVat,
      listPaymentMethod,
      listCurrency,
      listAllProduct,
      listAllAccountBank,
      listAllCustomer,
      dataConfigInvoice,
    ],
    result: [
      resultVat,
      resultPaymentMethod,
      resultCurrency,
      resultAllProduct,
      resultAllAccountBank,
      resultAllCustomer,
      resultConfigInvoice,
    ],
  } = useConfigInvoiceField(
    { keyWord: inputProductSearch },
    {
      listVats: true,
      listPaymentMethods: false,
      listCurrencies: true,
      listAllProduct: false,
      listAllAccountBank: false,
      listAllCustomer: true,
      configInvoice: true,
    },
    isOpenModal,
    buStoreHeader
  );

  useImperativeHandle(ref, () => ({
    releaseFromDetail() {
      handleSubmit(onAllowRelease, beforeAllowRelease)();
    },
  }));

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["warehouseAgency"]);
  const { addToast } = useToasts();
  const [disableForm, setDisableForm] = useState(true);
  const [isEditableAdjustReplace, setIsEditableAdjustReplace] = useState(true);
  const history = useHistory();
  // Search modal
  const [modalSearch, setModalSearch] = useState(false);
  const toggleSearchModal = () => setModalSearch(!modalSearch);

  // AccountBank modal
  const [modalAccountBank, setModalAccountBank] = useState(false);
  const toggleAddAccountBankModal = () =>
    setModalAccountBank(!modalAccountBank);

  // Product upload excel modal
  const [modalImportProduct, setModalImportProduct] = useState(false);
  const toggleImportProductModal = () =>
    setModalImportProduct(!modalImportProduct);

  // Product modal
  const [modalProduct, setModalProduct] = useState(false);
  const toggleAddProductModal = () => setModalProduct(!modalProduct);

  const [isTypeAdjustIncDesc, setIsTypeAdjustIncDesc] = useState(false);
  const [isTypeAdjustChangeInfo, setIsTypeAdjustChangeInfo] = useState(false);
  const [isShowLimitAdjust, setIsShowLimitAdjust] = useState(false);

  const [isReleaseGlobal, setIsReleaseGlobal] = useState(false);

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    loadingCreate,
    errorCreate,
    create: issueInvoiceCreate,

    loadingEdit,
    errorEdit,
    edit: issueInvoiceEdit,

    uploadFile,
    loadingUploadFile,
    invoiceMaxDate,
    invoiceMaxMinDate,
    type: typeInvoice,
    createInvoiceEnterpriseAdjustAllData,

    currentTime,
  } = issueInvoice;

  const {
    loading: loadingDetail,
    data: detailIssueInvoice,
    error,
  } = issueInvoice.detailIssueInvoice;
  const {
    loading: loadDingEnterpriseByTaxCode,
    data: enterpriseByTaxCode,
    error: errorEnterprise,
  } = issueInvoice.enterpriseByTaxCode;

  //   const listPageViewHaveTSUAT = [
  //     issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
  //     issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
  //     issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
  //     issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
  //   ];

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail

  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const [typeAnother, setTypeAnother] = useState(null);
  const modal = useRef(null);
  const modalTable = useRef(null);
  const setDefaultConfigField = () => {
    const defaultBusinessUnitInfoField = {
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_TEN.field]: "ten",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_MST.field]: "mst",
      [ISSUE_INVOICE_SELLER_FIELD.NBAN_DCHI.field]: "dchi",
      //   [ISSUE_INVOICE_SELLER_FIELD.NBAN_DCTDTU.field]: "dctdtu",
      //   [ISSUE_INVOICE_SELLER_FIELD.NBAN_FAX.field]: "fax",
      //   [ISSUE_INVOICE_SELLER_FIELD.NBAN_SDTHOAI.field]: "sdthoai",
      //   [ISSUE_INVOICE_SELLER_FIELD.NBAN_STKNHANG.field]: "stknhang",
      //   [ISSUE_INVOICE_SELLER_FIELD.NBAN_TNHANG.field]: "tnhang",
      //   [ISSUE_INVOICE_SELLER_FIELD.NBAN_WEBSITE.field]: "website",
    };
    if (finalBuReleaseInfo) {
      for (const key in defaultBusinessUnitInfoField) {
        const defaultValue =
          finalBuReleaseInfo[defaultBusinessUnitInfoField[key]];
        // if (key === ISSUE_INVOICE_SELLER_FIELD.NBAN_STKNHANG.field) {
        //   setValue(key, {
        //     value: defaultValue,
        //     label: defaultValue,
        //   });
        // } else {
        if (defaultValue) {
          setValue(key, defaultValue);
        } else {
          setValue(key, "");
        }
        // }
      }
    }
    // Set config hình thức thanh toán
    // setHTTTOAN(listPaymentMethod);
    // setValue(COMMON_FIELD.TTCHUNG_HTTTOAN.field, listPaymentMethod[0]);

    // Set config đơn vị tiền tệ
    setDVTTE(listCurrency);
    setValue(COMMON_FIELD.TTCHUNG_DVTTE.field, listCurrency?.[0]);

    // Set config thuế suất
    setTSUAT(listVat);

    setOPTION_GROUP({
      ...OPTION_GROUP,
      [COMMON_FIELD.TTCHUNG_DVTTE.field]: listCurrency,
      [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]: listAllProduct?.map(item => {
        return {
          ...item,
          value: item.code,
          label: item.code,
        };
      }),
      [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: listAllProduct,
      //   [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: listVat,
      //   [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.TSUAT.field]: listVat,
      //   [BUYER_FIELD.NMUA_STKNHANG.field]: customerInvoice?.listAllAccountBank,
      //   [BUYER_FIELD.NMUA_MKHANG.field]: customerInvoice?.listAllCustomer,
    });

    if (!isLoadingConfigField) {
      setTimeout(() => {
        if (modal && modal.current) {
          modal.current.scrollTop = 0;
        }
      });
    }
  };

  const COMMON_FIELD = ISSUE_INVOICE_COMMON_FIELD;
  const COMMON_FIELD_ARRAY = [];
  for (const key in COMMON_FIELD) {
    COMMON_FIELD_ARRAY.push(key);
  }

  const SELLER_FIELD = ISSUE_INVOICE_SELLER_FIELD;
  const SELLER_FIELD_ARRAY = [];
  for (const key in SELLER_FIELD) {
    SELLER_FIELD_ARRAY.push(key);
  }

  const BUYER_FIELD = ISSUE_INVOICE_BUYER_FIELD;
  const BUYER_FIELD_ARRAY = [];
  for (const key in BUYER_FIELD) {
    BUYER_FIELD_ARRAY.push(key);
  }

  const HHDV_FIELD = ISSUE_INVOICE_HHDV_FIELD;
  const HHDV_FIELD_ARRAY = [];
  for (const key in HHDV_FIELD) {
    HHDV_FIELD_ARRAY.push(key);
  }
  const TCHAT_VALUES =
    ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.TCHAT.selectValues;

  //   const PAYMENT_FIELD = ISSUE_INVOICE_PAYMENT_FIELD;
  //   const PAYMENT_FIELD_ARRAY = [];
  //   for (const key in PAYMENT_FIELD) {
  //     PAYMENT_FIELD_ARRAY.push(key);
  //   }

  const OPTION_TTCHUNG_KHMSHDON = [
    {
      value: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.WAREHOUSE_AGENCY,
      label: COMMON_FIELD.TTCHUNG_KHMSHDON.selectValues.WAREHOUSE_AGENCY + "",
    },
  ];
  //   const OPTION_TTCHUNG_HDDCKPTQUAN = [
  //     {
  //       value: "1",
  //       label: "1 - phiếu xuất kho dành cho tổ chức, cá nhân trong khu phi thuế quan",
  //     },
  //     {
  //       value: "0",
  //       label:
  //         "0 - phiếu xuất kho dành cho tổ chức, cá nhân không nằm trong khu phi thuế quan",
  //     },
  //   ];

  const OPTION_HHDV_TCHAT = [
    {
      value: TCHAT_VALUES.GOODS,
      label: "Hàng hóa, dịch vụ",
    },
    {
      value: TCHAT_VALUES.PROMOTION,
      label: "Khuyến mãi",
    },
    {
      value: TCHAT_VALUES.DISCOUNT,
      label: "Chiết khấu thương mại",
    },
    {
      value: TCHAT_VALUES.EXPLAIN,
      label: "Ghi chú/diễn giải",
    },
  ];

  const [OPTION_TTCHUNG_DVTTE, setDVTTE] = useState([]);
  const [OPTION_HHDV_TSUAT, setTSUAT] = useState([]);

  const [OPTION_GROUP, setOPTION_GROUP] = useState({
    [COMMON_FIELD.TTCHUNG_KHMSHDON.field]: OPTION_TTCHUNG_KHMSHDON,
    // [COMMON_FIELD.TTCHUNG_HDDCKPTQUAN.field]: OPTION_TTCHUNG_HDDCKPTQUAN,
    [COMMON_FIELD.TTCHUNG_DVTTE.field]: OPTION_TTCHUNG_DVTTE,
    // [COMMON_FIELD.TTCHUNG_HTTTOAN.field]: OPTION_TTCHUNG_HTTTOAN,
    [HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]: OPTION_HHDV_TCHAT,
    // [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: OPTION_HHDV_TSUAT,
    // [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.TSUAT.field]: OPTION_HHDV_TSUAT,
    // [ISSUE_INVOICE_SELLER_FIELD.NBAN_STKNHANG.field]: [],
    // [ISSUE_INVOICE_BUYER_FIELD.NMUA_STKNHANG.field]: [],
    // [ISSUE_INVOICE_BUYER_FIELD.NMUA_MKHANG.field]: [],
  });

  const objSchema = {};
  const initDefaultValues = {};
  const TOTAL_FIELD = {
    ...COMMON_FIELD,
    ...SELLER_FIELD,
    ...BUYER_FIELD,
    ...HHDV_FIELD,
    // ...PAYMENT_FIELD,
  };

  const TOTAL_FIELD_ARRAY = [
    ...COMMON_FIELD_ARRAY,
    ...SELLER_FIELD_ARRAY,
    ...BUYER_FIELD_ARRAY,
    ...HHDV_FIELD_ARRAY,
    // ...PAYMENT_FIELD_ARRAY,
  ];

  TOTAL_FIELD_ARRAY.map(item => {
    const itemField = TOTAL_FIELD[item];
    switch (itemField.type) {
      case "text":
        initDefaultValues[itemField.field] = "";

        objSchema[itemField.field] = yup.string();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.char_max", { max: itemField.max })
          );
        }
        if (itemField.isEmail) {
          objSchema[itemField.field] = objSchema[itemField.field].email(
            t("form.validate.invalid", { title: t(`form.${itemField.field}`) })
          );
        }
        if (itemField.isTaxCode) {
          objSchema[itemField.field] = objSchema[itemField.field].test(
            "len",
            "Vui lòng nhập tối đa 14 ký tự",
            val => val.length === 0 || val.length <= 14
          );
        }
        if (itemField.isKHHD) {
          //   objSchema[itemField.field] = objSchema[itemField.field].matches(
          //     /^[A]*$/,
          //     "Vui lòng chỉ nhập các ký tự (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)"
          //   );
          // objSchema[itemField.field] = objSchema[itemField.field].test(
          //   "len",
          //   "Vui lòng nhập 2 ký tự cuối (A, B, C, D, E, G, H, K, L, M, N, P, Q, R, S, T, U, V, X, Y)",
          //   val => {
          //     return val.length === 6;
          //   }
          // );
          initDefaultValues[itemField.field] = undefined;

          objSchema[itemField.field] = objSchema[itemField.field];
          objSchema[itemField.field] = yup.object();
          if (itemField.required) {
            objSchema[itemField.field] = objSchema[itemField.field].required(
              t("form.validate.select", { title: t(`form.${itemField.field}`) })
            );
          }
        }
        // Nếu có nhập MST người mua thì phải nhập địa chỉ
        if (itemField.field === ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field) {
          objSchema[itemField.field] = objSchema[itemField.field].when(
            ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field,
            {
              is: name => name.length > 0,
              then: yup.string().required(
                t("form.validate.required", {
                  title: t(`form.${ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field}`),
                })
              ),
            }
          );
        }
        // Nếu có nhập MST người mua thì phải nhập email
        // if (itemField.field === ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field) {
        //   objSchema[itemField.field] = objSchema[itemField.field].when(
        //     ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field,
        //     {
        //       is: name => name.length === 10 || name.length === 14,
        //       then: yup.string().required(
        //         t("form.validate.required", {
        //           title: t(
        //             `form.${ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field}`
        //           ),
        //         })
        //       ),
        //     }
        //   );
        // }
        break;
      case "number":
        initDefaultValues[itemField.field] = "";

        objSchema[itemField.field] = yup.string();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.required", { title: t(`form.${itemField.field}`) })
          );
        }

        // objSchema[itemField.field] = objSchema[itemField.field].matches(
        //   /^[0-9]+$/,
        //   t("form.validate.integer")
        // );

        if (itemField.max) {
          objSchema[itemField.field] = objSchema[itemField.field].max(
            itemField.max,
            t("form.validate.integer_max", { max: itemField.max })
          );
        }
        // Bắt buộc có tỷ giá (trừ đơn vị tiền tệ là VNĐ
        if (itemField.field === ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_TGIA.field) {
          objSchema[itemField.field] = objSchema[itemField.field].when(
            ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_DVTTE.field,
            {
              is: value => {
                return value.value !== "VND";
              },
              then: yup.string().required(
                t("form.validate.required", {
                  title: t(
                    `form.${ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_TGIA.field}`
                  ),
                })
              ),
            }
          );
        }
        break;
      case "select":
        // if (itemField.field === COMMON_FIELD.TTCHUNG_HDDCKPTQUAN.field) {
        //   initDefaultValues[itemField.field] = OPTION_TTCHUNG_HDDCKPTQUAN[1];
        // } else {
        initDefaultValues[itemField.field] = undefined;
        // }
        objSchema[itemField.field] = yup.object().nullable();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].required(
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        break;
      case "date":
        initDefaultValues[itemField.field] = [];

        objSchema[itemField.field] = yup.array();
        if (itemField.required) {
          objSchema[itemField.field] = objSchema[itemField.field].min(
            1,
            t("form.validate.select", { title: t(`form.${itemField.field}`) })
          );
        }
        break;
      case "field_array":
        objSchema[itemField.field] = yup
          .array()
          .min(1, t("form.validate.least_one_line"));
        const objSchemaFieldArray = {};

        const listField = itemField.list;
        const arrayField = [];
        for (const key in listField) {
          if (key !== "STT") {
            arrayField.push(key);
          }
        }

        arrayField.map(x => {
          const itemFieldArray = listField[x];
          switch (itemFieldArray.type) {
            case "text":
              objSchemaFieldArray[itemFieldArray.field] = yup
                .string()
                .nullable();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.required", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              if (itemFieldArray.max) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].max(
                  itemFieldArray.max,
                  t("form.validate.char_max", { max: itemFieldArray.max })
                );
              }
              break;
            case "number":
              objSchemaFieldArray[itemFieldArray.field] = yup
                .string()
                .nullable();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.required", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }

              //   objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
              //     itemFieldArray.field
              //   ].matches(/^[0-9]+$/, t("form.validate.integer"));

              if (itemFieldArray.max) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].max(
                  itemFieldArray.max,
                  t("form.validate.integer_max", { max: itemFieldArray.max })
                );
              }
              break;
            case "select":
              objSchemaFieldArray[itemFieldArray.field] = yup
                .object()
                .nullable();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].required(
                  t("form.validate.select", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              break;
            case "date":
              objSchemaFieldArray[itemFieldArray.field] = yup.array();
              if (itemFieldArray.required) {
                objSchemaFieldArray[itemFieldArray.field] = objSchemaFieldArray[
                  itemFieldArray.field
                ].min(
                  1,
                  t("form.validate.select", {
                    title: t(`form.${itemFieldArray.field}`),
                  })
                );
              }
              break;
            default:
              break;
          }
        });

        objSchema[itemField.field] = objSchema[itemField.field].of(
          yup.object().shape(objSchemaFieldArray)
        );
        break;
      case "object":
        objSchema[itemField.field] = yup.mixed().nullable();
        break;
      default:
        break;
    }
  });

  // ---Set Other Default Value---
  initDefaultValues[COMMON_FIELD.PBAN.field] = "2.0.0";
  initDefaultValues[COMMON_FIELD.TTCHUNG_SHDON.field] = "Chờ cấp số";

  initDefaultValues[COMMON_FIELD.TTCHUNG_NLAP.field] = [
    currentTime?.data?.date,
  ];
  initDefaultValues[COMMON_FIELD.TTCHUNG_TGIA.field] = 1;
  initDefaultValues[COMMON_FIELD.TTCHUNG_MSTTCGP.field] = "0302999571";
  //   initDefaultValues[COMMON_FIELD.TTCHUNG_DCDVNUNLHDON.field] = ""; // TODO not require in BE

  //   initDefaultValues[ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTCTHUE.field] = 0;
  //   initDefaultValues[ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTTHUE.field] = 0;
  //   initDefaultValues[ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TTCKTMAI.field] = 0;
  //   initDefaultValues[ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_TGTTTBSO.field] = 0;

  //CUSTOM_VIEW
  const FIRST_BLOCK = [
    ISSUE_INVOICE_SELLER_FIELD.NBAN_TEN,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_THDON,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_KHHDON,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_MST,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_SHDON,
    // ISSUE_INVOICE_SELLER_FIELD.NBAN_SDTHOAI,
    // ...ISSUE_INVOICE_COMMON_FIELD,
  ];

  const SECOND_BLOCK = [
    ISSUE_INVOICE_SELLER_FIELD.NBAN_HDSO,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_HDKTSO,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_HDKTNGAY,

    ISSUE_INVOICE_SELLER_FIELD.NBAN_HVTNXHANG,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_DCHI,
    ISSUE_INVOICE_SELLER_FIELD.NBAN_TNVCHUYEN,

    ISSUE_INVOICE_SELLER_FIELD.NBAN_PTVCHUYEN,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_MST,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN,

    ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI,
    ISSUE_INVOICE_BUYER_FIELD.NMUA_HVTNNHANG,

    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_DVTTE,
    ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_TGIA,
  ];
  //

  const schema = yup.object().shape(objSchema);
  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...initDefaultValues,
    },
  });
  const customerInvoice = useSelector(state => state.customerInvoice);

  const [isShowBtnAddCustomer, setIsShowBtnAddCustomer] = useState(false);

  useEffect(() => {
    if (isOpenModal && enterpriseByTaxCode?.taxCode) {
      if (
        listAllCustomer.findIndex(
          item => item.mst === enterpriseByTaxCode?.taxCode
        ) === -1
      ) {
        setIsShowBtnAddCustomer(true);
      } else {
        setIsShowBtnAddCustomer(false);
      }
    }
  }, [enterpriseByTaxCode]);

  // Action Dispatch
  useEffect(() => {
    console.log("error", errors);
  }, [errors]);

  const [listUploadFile, setListUploadFile] = useState([]);
  const [listHaveUploadFile, setListHaveUploadFile] = useState([]);
  // Action Dispatch
  useEffect(() => {
    if (uploadFile && uploadFile.success) {
      setListUploadFile([
        ...listUploadFile,
        { id: uploadFile.id, file_name: "" },
      ]);
      dispatch(resetUploadAttackFileInvoice());
    }
    // console.log("error", errors);
  }, [uploadFile]);

  const productInvoice = useSelector(state => state.productInvoice);

  useEffect(() => {
    if (listAllProduct) {
      //   console.log(
      //     "🚀 ~ file: DetailData.js ~ line 673 ~ useEffect ~ productInvoice",
      //     productInvoice
      //   );
      setOPTION_GROUP({
        ...OPTION_GROUP,
        [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]: listAllProduct?.map(item => {
          return {
            ...item,
            value: item.code,
            label: item.code,
          };
        }),
        [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: listAllProduct,
      });
    }
    // console.log("error", errors);
  }, [listAllProduct]);

  useEffect(() => {
    switch (productInvoice.type) {
      case CREATE_PRODUCT_INVOICE_SUCCESS:
        addToast("Thêm sản phẩm mới thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleAddProductModal();
        resultAllProduct.refetch();
        dispatch(resetCreateProductInvoice());
        break;
      case CREATE_PRODUCT_INVOICE_FAIL:
        if (
          productInvoice.createProduct.error.code === 422 &&
          productInvoice.createProduct.error.fields.length > 0
        ) {
          productInvoice.createProduct.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.create", {
                      target: t("product"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`Mã` + " không hợp lệ.")
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetCreateProductInvoice());
        break;
      default:
        break;
    }
  }, [productInvoice.type]);

  useEffect(() => {
    switch (customerInvoice.type) {
      case CREATE_ACCOUNT_BANK_SUCCESS:
        addToast("Thêm tài khoản thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleAddAccountBankModal();
        resultAllAccountBank.refetch();
        dispatch(resetCreateAccountBank());
        break;
      case CREATE_ACCOUNT_BANK_FAIL:
        if (
          customerInvoice.createAccountBankData.error.code === 422 &&
          customerInvoice.createAccountBankData.error.fields.length > 0
        ) {
          customerInvoice.createAccountBankData.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.create", {
                      target: t("product"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`Mã` + " không hợp lệ.")
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetCreateAccountBank());
        break;
      default:
        break;
    }
  }, [customerInvoice.type]);

  useEffect(() => {
    switch (typeInvoice) {
      case GET_INVOICE_MIN_DATE_SUCCESS:
        if (isOpenModal) {
          const currentNlap = getValues(
            ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field
          );
          checkDateWhenRelease(
            invoiceMaxMinDate.data.min,
            invoiceMaxMinDate.data.max,
            new Date(currentNlap),
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyDenyRelease(
                `Đã có phiếu xuất kho phát hành ngày ${maxDateLabel}. Vui lòng  cập nhật ngày lập của HĐ hiện tại về ${maxDateLabel} hoặc lớn hơn (nhưng phải nhỏ hơn ngày hiên tại).`
              );
              toggleDenyReleaseModal();
            },
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyCheckRelease(
                `Đang có phiếu xuất kho lưu tạm có ngày lập (${minDateLabel}) nhỏ hơn ngày lập của phiếu xuất kho hiện tại (${nlapLabel}), bạn có muốn tiếp tục phát hành phiếu xuất kho này hay không?`
              );
              toggleCheckReleaseModal();
            },
            () => {
              handleSubmit(onAllowRelease, beforeAllowRelease)();
            }
          );
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      case GET_INVOICE_MIN_DATE_FAIL:
        if (isOpenModal) {
          addToast(
            "Lấy thông tin ngày lập phiếu xuất kho lưu tạm xa nhất thất bại",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
          dispatch(resetGetInvoiceMinDate());
        }
        break;
      default:
        break;
    }
  }, [typeInvoice]);

  //   // Action Dispatch
  //   useEffect(() => {
  //     if (buStoreHeader) {
  //       dispatch(getAllAccountBank());
  //     }
  //   }, [buStoreHeader]);

  // setDefaultConfigField
  useEffect(() => {
    if (isSuccessConfigField && isOpenModal) {
      setDefaultConfigField();
      setValue(COMMON_FIELD.TTCHUNG_NLAP.field, [currentTime?.data?.date]);
      //
      if (dataConfirmAction?.typeAdjust !== TYPE_ADJUST_INVOICE.CHANGE_INFO) {
        addNewLineHHDV();
        addNewLineHHDV();
        addNewLineHHDV();
        addNewLineHHDV();
        addNewLineHHDV();
        // addNewLineTTOAN_LTSUAT();
      }
      if (dataDetail.id) {
        let isAdjustDecrease =
          dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE;
        dispatch(
          getDetailIssueInvoice(
            dataDetail.id,
            typeInvoiceAnother,
            null,
            isAdjustDecrease
          )
        );
      } else if (
        // Điều chỉnh thông tin phiếu xuất kho 32
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.CHANGE_INFO
      ) {
        defaultDataAdjustChangeInfo();
      }
      // Lập hóa đơn
      if (!dataDetail.id) {
        const khhdon = getValues(
          ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_KHHDON.field
        );
        const khmshdon = getValues(
          ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_KHMSHDON.field
        );
        dispatch(getInvoiceMaxDate(khmshdon, khhdon));
      }
    }
  }, [isSuccessConfigField, isOpenModal]);

  useEffect(() => {
    // Check ngày lập hiện tại với ngày phiếu xuất kho phát hành mới nhất
    if (
      isOpenModal &&
      invoiceMaxDate.data &&
      detailIssueInvoice
      //   !disableForm
    ) {
      if (mode.indexOf("VIEW_") > -1) {
        return;
      }
      const nlap = moment(
        new Date(getValues(ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field))
      ).format("YYYY-MM-DD");
      console.log(
        "🚀 ~ file: DetailInvoice.js ~ line 930 ~ useEffect ~ nlap",
        nlap
      );
      const maxDate = moment(invoiceMaxDate.data, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      console.log(
        "🚀 ~ file: DetailInvoice.js ~ line 1054 ~ useEffect ~ maxDate",
        maxDate
      );
      const checkRemove = nlap < maxDate;
      console.log(
        "🚀 ~ file: DetailInvoice.js ~ line 1059 ~ useEffect ~ checkRemove",
        checkRemove
      );
      if (checkRemove) {
        setValue(ISSUE_INVOICE_COMMON_FIELD.TTCHUNG_NLAP.field, [], {
          shouldValidate: true,
        });
      }
    }
  }, [invoiceMaxDate]);

  const setFileHaveUpload = () => {
    const listUploadFile = [];
    if (detailIssueInvoice?.resource_list) {
      for (const item of detailIssueInvoice.resource_list) {
        if (item.type === "attach") {
          const splitType = item?.file_name.split(".");
          const fileType = splitType[splitType.length - 1];
          listUploadFile.push({
            id: item.id,
            file_name: item.file_name.split("-")[0],
            file_type: fileType,
          });
        }
      }
      setListHaveUploadFile(listUploadFile);
    }
  };

  // Khi là trang riêng
  const handleWhenLoadFromPage = () => {
    if (isPage && detailIssueInvoice) {
      if (detailIssueInvoice.tthdlquan_tchdon) {
        let mode = null;
        if (detailIssueInvoice.tthdlquan_lhdclquan === "3") {
          mode = MODE_INVOICE_ACTION.REPLACE;
        } else {
          switch (detailIssueInvoice.tthdlquan_tchdon) {
            case "1":
              mode = MODE_INVOICE_ACTION.REPLACE;
              break;
            case "2":
              mode = MODE_INVOICE_ACTION.ADJUST;
              break;
            default:
              break;
          }
        }
        setDataConfirmAction({
          modeEdit: mode,
          typeAdjust: detailIssueInvoice.adjust_mod,
        });
      } else {
        setDataConfirmAction(null);
      }
      setPageViewByRow(detailIssueInvoice);
      const canEdit =
        checkVisibleByConditionRowData(
          COMMON_CONDITION_VISIBLE.EDIT,
          detailIssueInvoice
        ) ||
        checkVisibleByConditionRowData(
          COMMON_CONDITION_VISIBLE.EDIT_QUEUE_MSEAG,
          detailIssueInvoice
        );
      setDisableForm(canEdit ? false : true);
      setMode(
        canEdit
          ? issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL
          : issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL
      );
    }
  };

  useEffect(() => {
    if (detailIssueInvoice) {
      dispatch(
        getInvoiceMaxDate(
          detailIssueInvoice?.ttchung_khmshdon,
          changeYearOfSerial(
            detailIssueInvoice?.ttchung_khhdon,
            currentTime?.data?.year.toString()
          ),
          detailIssueInvoice?.bu_code
        )
      );
      handleWhenLoadFromPage();
      // Check show Hạn mức điều chỉnh
      if (
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE &&
        (dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST || // Tạo mới phiếu xuất kho điều chỉnh
          (dataConfirmAction?.modeEdit === MODE_INVOICE_ACTION.ADJUST && // phiếu xuất kho điều chỉnh lưu tạm
            detailIssueInvoice?.auth_status === AUTH_STATUS_NEW))
      ) {
        setIsShowLimitAdjust(true);
      }
      //Disalbe custom field nếu có
      if (
        detailIssueInvoice.is_editable === 0 ||
        detailIssueInvoice.is_editable === false
        //   &&
        // // Điều chỉnh giảm và thay thế mode tạo mới lần đầu
        // (dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
        //   (dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST &&
        //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE) ||
        //   // Điều chỉnh giảm và thay thế mode lần sau
        //   dataConfirmAction?.modeEdit === MODE_INVOICE_ACTION.REPLACE ||
        //   (dataConfirmAction?.modeEdit === MODE_INVOICE_ACTION.ADJUST &&
        //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE))
      ) {
        setIsEditableAdjustReplace(false);
      }
      // Nếu là phiếu xuất kho điều chỉnh giảm lần đầu thì gợi ý âm số lượng
      let isCreateAdjustDecreaseInvoice =
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE &&
        !dataConfirmAction.modeEdit &&
        mode !== issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL;
      setFileHaveUpload();
      setDefaultValue(COMMON_FIELD);
      setDefaultValue(ISSUE_INVOICE_SELLER_FIELD);
      setDefaultValue(ISSUE_INVOICE_BUYER_FIELD);
      //   setDefaultValue(ISSUE_INVOICE_PAYMENT_FIELD);
      setValue("send_mail", detailIssueInvoice.send_mail);
      //   const ttoan_ltsuatList = detailIssueInvoice.ttoan_ltsuat;
      //   if (ttoan_ltsuatList && ttoan_ltsuatList.length > 0) {
      //     setValue(
      //       ISSUE_INVOICE_PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field,
      //       ttoan_ltsuatList.map(item => {
      //         let ttoanTsuat = listVat.find(
      //           option => option.label === item.TSuat
      //         );
      //         // Trường hợp tsuat là input value
      //         if (item.TSuat && !ttoanTsuat) {
      //           ttoanTsuat = {
      //             value: item.TSuat.replace("%", ""),
      //             label: item.TSuat,
      //           };
      //         }
      //         return {
      //           ttoan_tsuat: ttoanTsuat,
      //           ttoan_thtien: item.ThTien,
      //           ttoan_tthue: item.TThue,
      //         };
      //       })
      //     );
      //   }
      const invoiceDetails = detailIssueInvoice.invoiceDetails;
      // Nếu điều chỉnh thông tin lần đầu
      if (
        dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.CHANGE_INFO &&
        !dataConfirmAction.modeEdit &&
        mode !== issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL
      ) {
        defaultDataAdjustChangeInfo();
      } else if (invoiceDetails && invoiceDetails.length > 0) {
        // set detail value cho THÔNG TIN DANH SÁCH HDDV
        // tchat mhhdvu thhdvu dvtinh sluong dgia tlckhau stckhau tsuat thtien ttkhac
        setValue(
          ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.field,
          invoiceDetails.map(item => {
            //Thuế suất
            let tsuatDetail = null;
            if (item.tsuat) {
              tsuatDetail = listVat.find(option => option.label === item.tsuat);
              // Trường hợp tsuat là input value
              if (!tsuatDetail) {
                tsuatDetail = {
                  value: Number(item.tsuat.replace(/KHAC:|.00%/g, "")),
                  label: item.tsuat,
                };
              }
            } else {
              tsuatDetail = {
                value: "",
                label: "",
              };
            }
            //Mã hàng hóa, dịch vụ, diễn giải
            // let mhhdvuDetail = null;
            // if (item.mhhdvu) {
            //   mhhdvuDetail = {
            //     value: item.mhhdvu,
            //     label: item.mhhdvu,
            //   };
            // }
            // //Tên hàng hóa, dịch vụ, diễn giải
            // let thhdvuDetail = {
            //   value: item.thhdvu,
            //   label: item.thhdvu,
            // };
            //

            let sluong = item.sluong;
            let thtien = item.thtien;
            let dgia = item.dgia;
            if (isCreateAdjustDecreaseInvoice) {
              //   sluong = 0;
              sluong = sluong > 0 ? -sluong : sluong;
              thtien = thtien > 0 ? -thtien : thtien;
            }
            return {
              tchat: OPTION_HHDV_TCHAT.find(
                option => Number(option.value) === Number(item.tchat)
              ),
              mhhdvu: item.mhhdvu,
              thhdvu: item.thhdvu,
              dvtinh: item.dvtinh,
              sluong: sluong,
              dgia: dgia,
              tlckhau: item.tlckhau,
              stckhau: item.stckhau,
              tsuat: tsuatDetail,
              thtien: thtien,
              ttkhac: item.ttkhac,
            };
          })
        );
      }
    }
  }, [detailIssueInvoice]);

  // Custom set default value
  const setDefaultValue = FIELDS => {
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      const finalValue = detailIssueInvoice[finalKey];
      if (finalValue) {
        switch (type) {
          case "object":
            setValue(finalKey, finalValue, { shouldValidate: true });
            break;
          case "select":
            const option = OPTION_GROUP[finalKey];
            if (option) {
              const valueSelect = option.find(
                item => item.value === finalValue
              );
              if (valueSelect) {
                setValue(finalKey, valueSelect, { shouldValidate: true });
              } else if (finalValue) {
                setValue(
                  finalKey,
                  {
                    value: finalValue,
                    label: finalValue,
                  },
                  { shouldValidate: true }
                );
              }
            }
            break;
          case "number":
          case "text":
            // Mode thay thế phiếu xuất kho và điều chỉnh
            if (
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST
            ) {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_SHDON.field:
                  setValue(finalKey, "Chờ cấp số");
                  break;
                case COMMON_FIELD.TTCHUNG_KHHDON.field:
                  // Set ký hiệu theo năm trên hệ thống
                  if (dataConfirmAction?.finalSerial) {
                    setTimeout(() => {
                      setValue(finalKey, dataConfirmAction?.finalSerial);
                    });
                  }
                  break;
                // case COMMON_FIELD.TTCHUNG_KHHDON.field:
                //   const subValue = String(finalValue).substring(
                //     String(finalValue).length - 2
                //   );

                //   const resultFind = invoiceSymbolList.find(
                //     item => item.khhdon === subValue
                //   );
                //   if (resultFind) {
                //     setValue(finalKey, {
                //       value: resultFind.id,
                //       label: resultFind.khhdon,
                //     });
                //   } else {
                //     setValue(finalKey, undefined);
                //   }
                //   break;
                default:
                  setValue(finalKey, finalValue);
                  break;
              }
            } else {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_KHHDON.field:
                  // Nếu sang năm thì phải tăng năm
                  const serial = changeYearOfSerial(
                    finalValue,
                    currentTime?.data?.year.toString()
                  );
                  setTimeout(() => {
                    setValue(finalKey, serial);
                  });
                  break;
                default:
                  setValue(finalKey, finalValue);
                  break;
              }
            }
            break;
          case "date":
            if (
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
              dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST
            ) {
              switch (finalKey) {
                case COMMON_FIELD.TTCHUNG_NLAP.field:
                  setValue(finalKey, [currentTime?.data?.date]);
                  break;
                default:
                  const date = formatTimestampToDate(finalValue);
                  setValue(finalKey, [date]);
                  break;
              }
            } else {
              const date = formatTimestampToDate(finalValue);
              setValue(finalKey, [date]);
            }
            break;
        }
      }
    }
  };

  const {
    fields: fieldsHHDV,
    append: appendHHDV,
    remove: removeHHDV,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: HHDV_FIELD.HHDV_OBJ.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  //   const {
  //     fields: fieldsTTOAN_LTSUAT,
  //     append: appendTTOAN_LTSUAT,
  //     remove: removeTTOAN_LTSUAT,
  //   } = useFieldArray({
  //     control, // control props comes from useForm (optional: if you are using FormContext)
  //     name: PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field, // unique name for your Field Array
  //     keyName: "key", // keyName: "id", default to "id", you can change the key name
  //   });

  //   const {
  //     fields: fieldsTTOAN_LPHI,
  //     append: appendTTOAN_LPHI,
  //     remove: removeTTOAN_LPHI,
  //   } = useFieldArray({
  //     control, // control props comes from useForm (optional: if you are using FormContext)
  //     name: PAYMENT_FIELD.TTOAN_LPHI_OBJ.field, // unique name for your Field Array
  //     keyName: "key", // keyName: "id", default to "id", you can change the key name
  //   });

  const setTypeInvoice = () => {
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE:
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE:
        setTypeAnother(TYPE_INVOICE_ANOTHER.WAREHOUSE_AGENCY);
        break;
      default:
        break;
    }
  };

  const resetTable = () => {
    setCurrentPage(0);
    setItemOffset(0);
    setItemsPerPage(listSizePerPage[0]);
    setPageCount(0);
  };

  useEffect(() => {
    if (!isOpenModal) {
      setIsReleaseGlobal(false);
      dispatch(resetGetInvoiceMaxDate());
      setIsShowLimitAdjust(false);
      setIsEditableAdjustReplace(true);
      dispatch(resetGetDetailIssueInvoice());
      setIsDetail(false);
      reset({ ...initDefaultValues });
      dispatch(resetGetEnterpriseByTaxCode());
      resetTable();
      setIsShowBtnAddCustomer(false);
      // setControlFields(initControlFields);
    } else {
      setListUploadFile([]);
      checkDisableForm();
      setTypeInvoice();
      //   dispatch(loadConfigInvoiceField());
      //   addNewLineTTOAN_LPHI();
      switch (mode) {
        case issueInvoiceModeList.CREATE_WAREHOUSE_AGENCY_DETAIL:
          setValue(
            COMMON_FIELD.TTCHUNG_THDON.field,
            "PHIẾU XUẤT KHO GỬI BÁN ĐẠI LÝ"
          );
          setValue(
            COMMON_FIELD.TTCHUNG_KHMSHDON.field,
            OPTION_TTCHUNG_KHMSHDON[0].value,
            { shouldValidate: true }
          );
          setValue(COMMON_FIELD.TTCHUNG_KHHDON.field, khhdonDefault, {
            shouldValidate: true,
          });
          break;
        default:
          break;
      }
      // setValue(COMMON_FIELD.TTCHUNG_KHHDON.field, khhdonDefault);
    }
  }, [dispatch, isOpenModal]);

  const checkDisableForm = () => {
    let isTypeAdjustIncDesc = false;
    let isTypeAdjustChangeInfo = false;
    setDisableForm(true);
    if (dataConfirmAction) {
      switch (dataConfirmAction.mode) {
        // Thay thế phiếu xuất kho
        case MODE_INVOICE_ACTION.REPLACE:
          setDisableForm(false);
          break;
        // Điều chỉnh phiếu xuất kho
        case MODE_INVOICE_ACTION.ADJUST:
          switch (dataConfirmAction.typeAdjust) {
            // Tăng, giảm
            case TYPE_ADJUST_INVOICE.INCREASE:
            case TYPE_ADJUST_INVOICE.DECREASE:
              isTypeAdjustIncDesc = true;
              //   setDisableForm(false);
              break;
            // Điều chỉnh thông tin
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              //   setDisableForm(true);
              isTypeAdjustChangeInfo = true;
              break;
            default:
              break;
          }
          setDisableForm(true);
          break;
        default:
          break;
      }
      // Cập nhật lại phiếu xuất kho điều chỉnh/thay thế ở trạng thái lưu tạm
      switch (dataConfirmAction.modeEdit) {
        // Thay thế phiếu xuất kho
        case MODE_INVOICE_ACTION.REPLACE:
          setDisableForm(false);
          break;
        // Điều chỉnh phiếu xuất kho
        case MODE_INVOICE_ACTION.ADJUST:
          switch (dataConfirmAction.typeAdjust) {
            // Tăng, giảm
            case TYPE_ADJUST_INVOICE.INCREASE:
            case TYPE_ADJUST_INVOICE.DECREASE:
              isTypeAdjustIncDesc = true;
              //   setDisableForm(false);
              break;
            // Điều chỉnh thông tin
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              //   setDisableForm(true);
              isTypeAdjustChangeInfo = true;
              break;
            default:
              break;
          }
          setDisableForm(true);
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        case issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL:
          setDisableForm(true);
          break;
        default:
          setDisableForm(false);
          break;
      }
    }
    setIsTypeAdjustIncDesc(isTypeAdjustIncDesc);
    setIsTypeAdjustChangeInfo(isTypeAdjustChangeInfo);
  };

  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            ...optionDateLocale.locale,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            ...optionDateLocale.locale,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  // Action Dispatch
  useEffect(() => {
    if (issueInvoiceCreate && issueInvoiceCreate.success) {
      addToast(t("form.submit.create.invoice.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetCreateIssueInvoice());
      toggleModal(mode);
    }
  }, [addToast, dispatch, issueInvoiceCreate, mode, t, toggleModal]);

  // Action Dispatch
  useEffect(() => {
    if (issueInvoiceEdit && issueInvoiceEdit.success) {
      dispatch(resetEditIssueInvoice());
      if (isReleaseGlobal) {
        setIsReleaseGlobal(false);
        addToast("Gửi phát hành phiếu xuất kho thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleModal(mode, true);
        return;
      } else {
        addToast(t("form.submit.edit.invoice.success"), {
          appearance: "success",
          autoDismiss: true,
        });
      }
      if (isPage) {
        history.push("/invoice-warehouses-agency");
      } else {
        toggleModal(mode);
      }
    }
  }, [addToast, dispatch, issueInvoiceEdit, mode, t, toggleModal]);

  // Error Dispatch
  useEffect(() => {
    if (errorCreate) {
      addToast(t("form.submit.create.invoice.error"), {
        appearance: "error",
        autoDismiss: true,
      });

      if (errorCreate.code === 422 && errorCreate.fields.length > 0) {
        errorCreate.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            // case "ttoan_ltsuat":
            //   fieldName = PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field;
            //   break;
            // case "ttoan_lphi":
            //   fieldName = PAYMENT_FIELD.TTOAN_LPHI_OBJ.field;
            //   break;
            case "listInvoiceDetail":
              fieldName = HHDV_FIELD.HHDV_OBJ.field;
              break;
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, { type: "manual", message: item.message });
          addToast(item.message, {
            appearance: "error",
            autoDismiss: true,
          });
        });
      }
      dispatch(resetCreateIssueInvoice());
    }

    if (errorEdit) {
      addToast(errorEdit, {
        appearance: "error",
        autoDismiss: true,
      });
      if (isReleaseGlobal) {
        setIsReleaseGlobal(false);
        addToast("Gửi phát hành phiếu xuất kho thất bại", {
          appearance: "success",
          autoDismiss: true,
        });
      } else {
        addToast(t("form.submit.edit.invoice.error"), {
          appearance: "error",
          autoDismiss: true,
        });
      }

      if (errorEdit.code === 422 && errorEdit.fields.length > 0) {
        errorEdit.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            // case "ttoan_ltsuat":
            //   fieldName = PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field;
            //   break;
            // case "ttoan_lphi":
            //   fieldName = PAYMENT_FIELD.TTOAN_LPHI_OBJ.field;
            //   break;
            case "listInvoiceDetail":
              fieldName = HHDV_FIELD.HHDV_OBJ.field;
              break;
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, { type: "manual", message: item.message });
          addToast(item.message, {
            appearance: "error",
            autoDismiss: true,
          });
        });
      }
      dispatch(resetEditIssueInvoice());
    }
  }, [
    HHDV_FIELD.HHDV_OBJ.field,
    // PAYMENT_FIELD.TTOAN_LPHI_OBJ.field,
    // PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.field,
    addToast,
    dispatch,
    errorCreate,
    errorEdit,
    setError,
    t,
  ]);

  const onSentApprove = values => {
    onSubmit(values, true);
  };
  const beforeSendApprove = values => {
    beforeSubmit(values, true);
  };

  const onRelease = values => {
    onSubmit(values, false, true);
  };
  const beforeRelease = values => {
    beforeSubmit(values, false, true);
  };

  const onAllowRelease = values => {
    onSubmit(values, false, true, true);
  };
  const beforeAllowRelease = values => {
    beforeSubmit(values, false, true, true);
  };

  const onSubmit = (
    values,
    isSubmit = false,
    isRelease = false,
    isAllowRelease = false
  ) => {
    // Check phát hành sau khi cập nhật/
    setIsReleaseGlobal(isRelease);
    // Điều chỉnh giảm k dc vượt hạn mức điều chỉnh
    // if (
    //   isShowLimitAdjust &&
    //   Math.abs(values.ttoan_tgtttbso) > detailIssueInvoice?.limit
    // ) {
    //   addToast(
    //     "Tổng tiền thanh toán bằng số không được vượt hạn mức điều chỉnh",
    //     {
    //       appearance: "error",
    //       autoDismiss: true,
    //     }
    //   );
    //   return;
    // }
    const isSaveInfoCustomer = values.isSaveInfoCustomer;
    const finalData = formatData(values);
    // lưu thông tin kh
    finalData["isSaveInfoCustomer"] = isSaveInfoCustomer;
    // Gửi mail
    finalData["send_mail"] = inputCBSendMailChange ? 1 : 0;
    // // Remove thue suat
    // if (listPageViewHaveTSUAT.indexOf(pageView) === -1) {
    //   for (const item of finalData["listInvoiceDetail"]) {
    //     item["tsuat"] = "";
    //   }
    //   finalData["ttoan_ltsuat"] = "";
    // }
    // // Nếu là phiếu xuất kho điều chỉnh thông tin thì remove thuế suất
    // if (isTypeAdjustChangeInfo) {
    //   for (const item of finalData["listInvoiceDetail"]) {
    //     item["tsuat"] = "";
    //   }
    //   finalData["ttoan_ltsuat"] = [
    //     {
    //       TSuat: "0%",
    //       ThTien: 0,
    //       TThue: 0,
    //     },
    //   ];
    // }
    // list sản phẩm check để tái sử dụng
    const listProduct = values.hhdv_obj
      .filter(item => item.mhhdvu)
      .map(item => {
        return {
          code: item?.mhhdvu,
          name: item?.thhdvu,
          unit: item?.dvtinh,
          price: item?.dgia,
          id_vat: item?.tsuat?.id,
          vat_text: item?.tsuat?.label,
        };
      });
    switch (pageView) {
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_HAVE_CODE:
        finalData["invoice_type"] = "1";
        break;
      case issueInvoicePageViewList.PAGE_WAREHOUSE_AGENCY_NONE_CODE:
        finalData["invoice_type"] = "0";
        break;
      default:
        break;
    }
    finalData.ttchung_shdon = null;
    if (dataConfirmAction) {
      // Lưu lại giá trị để khi thay thế /điều chỉnh xong thì gửi duyệt lun
      if (isSubmit) {
        btnShowFooter?.btnSubmitEdit?.onClick();
      }
      // Thay thế phiếu xuất kho
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          dispatch(
            replaceIssueInvoice(
              dataConfirmAction.id,
              listUploadFile.map(item => item.id),
              finalData,
              typeInvoiceAnother,
              dataConfirmAction.infoTT32
            )
          );
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          dispatch(
            adjustIssueInvoice(
              dataConfirmAction.id,
              listUploadFile.map(item => item.id),
              dataConfirmAction.typeAdjust,
              finalData,
              typeInvoiceAnother
            )
          );
          break;
        default:
          break;
      }
      // Thay thế phiếu xuất kho
      switch (dataConfirmAction.modeEdit) {
        case MODE_INVOICE_ACTION.REPLACE:
        case MODE_INVOICE_ACTION.ADJUST:
          finalData.adjust_mod = detailIssueInvoice.adjust_mod;
          let auto_sign = isRelease ? 1 : 0;
          if (isRelease) {
            if (isAllowRelease) {
              dispatch(
                editIssueInvoice(
                  finalData,
                  dataDetail.id,
                  typeInvoiceAnother,
                  auto_sign
                )
              );
            } else {
              dispatch(
                getInvoiceMinDate(
                  detailIssueInvoice?.ttchung_khmshdon,
                  changeYearOfSerial(
                    detailIssueInvoice?.ttchung_khhdon,
                    currentTime?.data?.year.toString()
                  ),
                  detailIssueInvoice?.bu_code
                )
              );
            }
          } else {
            dispatch(
              editIssueInvoice(finalData, dataDetail.id, typeInvoiceAnother)
            );
          }
          break;
        default:
          break;
      }
    } else {
      // Gửi duyệt phiếu xuất kho khi tạo phiếu xuất kho lun
      if (isSubmit) {
        setDataInvoiceTemp({
          finalData: finalData,
          typeAnother: typeInvoiceAnother,
          listProduct: listProduct,
        });
        btnShowFooter?.btnSubmit?.toggleModal &&
          btnShowFooter?.btnSubmit?.toggleModal();
      } else {
        // THêm sản phẩm mới
        dispatch(createListProductInvoice(listProduct));
        switch (mode) {
          case issueInvoiceModeList.CREATE_WAREHOUSE_AGENCY_DETAIL:
            dispatch(createIssueInvoice(finalData, typeInvoiceAnother));
            break;
          case issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL:
          case issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL:
            let auto_sign = isRelease ? 1 : 0;
            if (isRelease) {
              if (isAllowRelease) {
                dispatch(
                  editIssueInvoice(
                    finalData,
                    dataDetail.id,
                    typeInvoiceAnother,
                    auto_sign
                  )
                );
              } else {
                dispatch(
                  getInvoiceMinDate(
                    detailIssueInvoice?.ttchung_khmshdon,
                    changeYearOfSerial(
                      detailIssueInvoice?.ttchung_khhdon,
                      currentTime?.data?.year.toString()
                    ),
                    detailIssueInvoice?.bu_code
                  )
                );
              }
            } else {
              dispatch(
                editIssueInvoice(finalData, dataDetail.id, typeInvoiceAnother)
              );
            }
            break;
          default:
            break;
        }
      }
    }
  };

  const beforeSubmit = (
    values,
    isSubmit = false,
    isRelease = false,
    isAllowRelease = false
  ) => {
    // Remove những hàng hóa dịch vụ không hợp lệ ( K có tên hàng hóa)
    const totalHHDVCount = fieldsHHDV.length;
    const errorHHDV = values?.hhdv_obj;
    if (errorHHDV) {
      let listIndexRemove = [];
      errorHHDV.forEach((value, i) => {
        listIndexRemove.push(Number(i));
      });
      const errorHHDVCount = errorHHDV?.filter(item => item.thhdvu).length;
      if (
        Object.keys(values).length === 1 &&
        values?.hhdv_obj &&
        errorHHDVCount < totalHHDVCount
      ) {
        if (listIndexRemove) {
          const currentList = getValues(HHDV_FIELD.HHDV_OBJ.field);
          const filtered = currentList.filter(function (value, index, arr) {
            return !listIndexRemove.includes(index);
          });
          setValue(HHDV_FIELD.HHDV_OBJ.field, filtered, {
            shouldValidate: true,
          });
          setTimeout(() => {
            handleSubmit(async data =>
              onSubmit(data, isSubmit, isRelease, isAllowRelease)
            )();
          });
        }
      }
    }
  };

  const getKhhdDefault = () => {
    if (detailIssueInvoice && isOpenModal) {
      return detailIssueInvoice
        ? detailIssueInvoice?.ttchung_khhdon?.substring(
            0,
            detailIssueInvoice?.ttchung_khhdon.length - 2
          )
        : khhdonDefault;
    }
    return khhdonDefault;
  };

  const formatData = values => {
    const finalData = {};

    TOTAL_FIELD_ARRAY.map(item => {
      const itemField = TOTAL_FIELD[item];
      const valueField = values[itemField.field];
      switch (itemField.type) {
        case "object":
          finalData[itemField.field] = valueField;
          break;
        case "text":
          //   if (itemField.field === "ttchung_khhdon") {
          //     finalData[itemField.field] = `${getKhhdDefault()}${
          //       valueField?.value ? valueField.label : ""
          //     }`;
          //   } else {
          finalData[itemField.field] = valueField.trim() || "";
          //   }
          break;
        case "number":
          finalData[itemField.field] = Number(valueField);
          break;
        case "select":
          finalData[itemField.field] = valueField?.value
            ? valueField.value
            : "";
          break;
        case "date":
          if (itemField.field === COMMON_FIELD.TTCHUNG_NLAP.field) {
            finalData[itemField.field] = convertDate(
              valueField[0],
              "YYYY-MM-DD"
            );
          } else {
            finalData[itemField.field] = convertDate(valueField[0]);
          }
          break;
        case "field_array":
          finalData[itemField.fieldReal] = [];

          const listField = itemField.list;
          const arrayField = [];
          for (const key in listField) {
            arrayField.push(key);
          }
          let stt = 0;
          finalData[itemField.fieldReal] =
            valueField &&
            valueField.map(fieldChild => {
              stt = stt + 1;
              const finalDataFieldArray = {};
              arrayField.map(y => {
                const itemFieldArray = listField[y];
                const valueFieldArray = fieldChild[itemFieldArray.field];
                if (y === "STT") {
                  finalDataFieldArray[itemFieldArray.fieldReal] = stt;
                } else {
                  // console.log(itemFieldArray.type, "itemFieldArray.type");
                  switch (itemFieldArray.type) {
                    case "text":
                      finalDataFieldArray[itemFieldArray.fieldReal] =
                        valueFieldArray || "";
                      break;
                    case "number":
                      let defaultValue = 0;
                      if (
                        itemFieldArray.fieldReal ===
                          HHDV_FIELD.HHDV_OBJ.list.SLUONG.field ||
                        itemFieldArray.fieldReal ===
                          HHDV_FIELD.HHDV_OBJ.list.DGIA.field
                      ) {
                        defaultValue = DEFAULT_NULL_NUMBER;
                      }
                      finalDataFieldArray[itemFieldArray.fieldReal] =
                        !isEmptyNumber(valueFieldArray)
                          ? Number(valueFieldArray)
                          : defaultValue;
                      break;
                    case "select":
                      if (
                        itemFieldArray.fieldReal === "tsuat" ||
                        itemFieldArray.fieldReal === "TSuat"
                      ) {
                        finalDataFieldArray[itemFieldArray.fieldReal] =
                          valueFieldArray && valueFieldArray.label;
                      } else {
                        finalDataFieldArray[itemFieldArray.fieldReal] =
                          valueFieldArray?.value || "";
                      }
                      // Luu thêm giá trị thuế suất vào db
                      if (itemFieldArray.fieldReal === "tsuat") {
                        finalDataFieldArray["tsuat_value"] =
                          valueFieldArray?.value;
                      }
                      break;
                    case "date":
                      finalDataFieldArray[itemFieldArray.fieldReal] =
                        convertDate(valueFieldArray[0]);
                      break;
                    default:
                      break;
                  }
                }
              });
              return finalDataFieldArray;
            });
          break;
        default:
          break;
      }
    });

    return finalData;
  };

  const defaultValueLineHHDV = {
    [HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]: OPTION_HHDV_TCHAT[0],
    [HHDV_FIELD.HHDV_OBJ.list.STT.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.DVTINH.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.SLUONG.field]: DEFAULT_NULL_NUMBER,
    [HHDV_FIELD.HHDV_OBJ.list.DGIA.field]: DEFAULT_NULL_NUMBER,
    // [HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field]: "",
    // [HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field]: "",
    [HHDV_FIELD.HHDV_OBJ.list.THTIEN.field]: 0,
    // [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: listVat[0],
    [HHDV_FIELD.HHDV_OBJ.list.TTKHAC.field]: "",
  };

  //   const defaultValueLineTTOAN_LTSUAT = {
  //     [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.TSUAT.field]: {
  //       value: "",
  //       label: "",
  //     },
  //     [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.THTIEN.field]: "",
  //     [PAYMENT_FIELD.TTOAN_LTSUAT_OBJ.list.TTHUE.field]: "",
  //   };

  //   const defaultValueLineTTOAN_LPHI = {
  //     [PAYMENT_FIELD.TTOAN_LPHI_OBJ.list.TLPHI.field]: "",
  //     [PAYMENT_FIELD.TTOAN_LPHI_OBJ.list.TPHI.field]: "",
  //   };

  const addNewLineHHDV = () => {
    appendHHDV(defaultValueLineHHDV);
    // setTimeout(() => {
    // });
  };

  const addNewRowHHDVHandle = () => {
    addNewLineHHDV();
    setIsAddNewLine(true);
    setIsLoadTable(true);
  };

  const removeNewRowHHDVHandle = index => {
    removeHHDV(index);
    setIsRemoveLine(true);
    setIsLoadTable(true);
  };

  //   const addNewLineTTOAN_LTSUAT = () => {
  //     appendTTOAN_LTSUAT(defaultValueLineTTOAN_LTSUAT);
  //   };
  //   const addNewLineTTOAN_LPHI = () => {
  //     appendTTOAN_LPHI(defaultValueLineTTOAN_LPHI);
  //   };

  const caculateHHDV = (fieldArray, index, fieldChild, customValue) => {
    const HHDV_OBJ = HHDV_FIELD.HHDV_OBJ;
    caculateHHDVCommon({
      fieldArray,
      index,
      fieldChild,
      customValue,
      HHDV_OBJ,
      getValues,
      watch,
      setValue,
      OPTION_HHDV_TSUAT,
      pageView,
      isWarehouses: true,
      defaultForeignDecimalScale:
        dataConfigInvoice?.decimal_place?.foreign_currency,
    });
  };

  // Delay when MST người bán  Change
  const [disableBtnInfoByTax, setDisableBtnInfoByTax] = useState(true);
  const [inputMSTChange, setInputMSTChange] = useState(null);
  const [inputCBSendMailChange, setInputCBSendMailChange] = useState(false);

  useEffect(() => {
    const delayDebounceTAXFn = setTimeout(() => {
      if (inputMSTChange) {
        if (inputMSTChange.length === 10 || inputMSTChange.length === 14) {
          dispatch(getEnterpriseByTaxCode(inputMSTChange));
        }
      }
    }, 500);
    return () => clearTimeout(delayDebounceTAXFn);
  }, [inputMSTChange]);

  useEffect(() => {
    if (!loadDingEnterpriseByTaxCode) {
      setDisableBtnInfoByTax(false);
    }
  }, [loadDingEnterpriseByTaxCode]);

  // Delay when input HDDV Change
  const [inputValueChange, setInputValueChange] = useState(null);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (inputValueChange) {
        caculateHHDV(
          inputValueChange.fieldArray,
          inputValueChange.index,
          inputValueChange.fieldChild
        );
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [inputValueChange]);
  //
  // We start with an empty list of items.
  const [listSizePerPage, setListSizePerPage] = useState([5, 20, 25, 50, 100]);
  const [itemsPerPage, setItemsPerPage] = useState(listSizePerPage[0]);
  const [currentItemsHHDV, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [isAddNewLine, setIsAddNewLine] = useState(false);
  const [isRemoveLine, setIsRemoveLine] = useState(false);
  const [isChangeSizePage, setIsChangeSizePage] = useState(false);

  const [isLoadTable, setIsLoadTable] = useState(false);

  const initNewPageItem = () => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(fieldsHHDV.slice(itemOffset, endOffset));
    let pageCount = Math.ceil(fieldsHHDV.length / itemsPerPage);
    setPageCount(pageCount);

    if (isChangeSizePage) {
      changeToPage(0);
      //   setIsChangeSizePage(false);
    } else {
      // Thêm item có page mới thì sang page mới
      if (isAddNewLine) {
        // setIsLoadTable(true);
        setIsAddNewLine(false);
        changeToPage(pageCount - 1);
      }
      // Xóa item
      if (isRemoveLine) {
        setIsRemoveLine(false);
        // Page hiện tại lớn hơn số page hiện có
        if (pageCount === currentPage) {
          // Lùi 1 page
          changeToPage(currentPage - 1);
        } else {
          // giữ nguyên page
          changeToPage(currentPage);
        }
      }
    }
  };

  useEffect(() => {
    if (currentItemsHHDV) {
      setIsLoadTable(false);
    }
  }, [currentItemsHHDV]);

  useEffect(() => {
    if (!isLoadTable && isOpenModal && modalTable && modalTable.current) {
      let scroll = null;
      if (isChangeSizePage) {
        setIsChangeSizePage(false);
        scroll = 0;
      } else {
        scroll = modalTable.current.scrollHeight;
      }
      modalTable.current.scrollTop = scroll;
    }
  }, [isLoadTable]);

  useEffect(() => {
    if (pageCount) {
      //   // Thêm item có page mới thì sang page mới
      //   if (isAddNewLine || isRemoveLine) {
      //     // setIsLoadTable(true);
      //     setIsAddNewLine(false);
      //     setIsRemoveLine(false);
      //     changeToPage(pageCount - 1);
      //   }
    }
  }, [pageCount]);

  useEffect(() => {
    // Fetch items from another resources.
    if (isOpenModal) {
      initNewPageItem();
    }
  }, [itemOffset, itemsPerPage, isOpenModal]);

  // Invoke when user click to request another page.
  const handlePageClick = event => {
    setIsLoadTable(true);
    changeToPage(event.selected);
  };

  const changeToPage = page => {
    const newOffset = (page * itemsPerPage) % fieldsHHDV.length;
    setItemOffset(newOffset);
    setCurrentPage(page);
  };

  // setDefaultConfigField
  useEffect(() => {
    if (fieldsHHDV && isOpenModal) {
      initNewPageItem();
    }
  }, [fieldsHHDV, isOpenModal]);

  const generateTable = (
    fieldContanst,
    listContanst,
    fieldsArray,
    removeFunc,
    addFunc,
    isAuto = false,
    styleTable = {}
  ) => {
    //
    let fieldDisableConfig = {};
    if (!isEditableAdjustReplace) {
      fieldDisableConfig = FIELD_DISABLE_CONFIG[fieldContanst];
    }
    return (
      <React.Fragment>
        <div
          ref={modalTable}
          className="custom-table-border hhdv-table"
          style={{ ...styleTable }}
        >
          <Table className="table  table-bordered">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "20px" }}>
                  STT
                </th>
                {Object.entries(listContanst)
                  .filter(([k, v]) => !v.isHide && checkShowWithPageView(v))
                  .map(([key, value]) => {
                    return (
                      <th
                        style={{ width: value.width }}
                        className="text-center"
                        key={key}
                      >
                        {t(`form.${value.field}`)}{" "}
                        {value.required && (
                          <span className="text-danger"> (*)</span>
                        )}
                      </th>
                    );
                  })}
                {!isAuto && isEditableAdjustReplace && (
                  <th style={{ width: "20px", textAlign: "center" }}>
                    {!disableForm && !isTypeAdjustIncDesc && (
                      <i
                        title="Thêm hàng hóa (F2)"
                        onClick={addFunc}
                        className="fas fa-plus  text-success label-icon"
                        style={{ cursor: "pointer" }}
                      ></i>
                    )}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {fieldsArray.map((field, indexOfItem) => {
                let index = currentPage * itemsPerPage + indexOfItem;
                // console.log(
                //   "🚀 ~ file: DetailData.js ~ line 1956 ~ {fieldsArray.map ~ index",
                //   index
                // );
                // console.log(
                //   "🚀 ~ file: DetailData.js ~ line 1956 ~ {fieldsArray.map ~ stt",
                //   index + 1
                // );
                // console.log("🚀 ~ ---------------------------");
                // if (watch(`hhdv_obj`)) {
                //   console.log("value", watch(`hhdv_obj`)[index]);
                // }
                const fieldMain = fieldContanst;
                const listField = listContanst;
                const arrayField = [];
                for (const key in listField) {
                  if (
                    !listField[key].isHide &&
                    checkShowWithPageView(listField[key])
                  ) {
                    arrayField.push(key);
                  }
                }
                const tdStyle = {
                  display: "table-cell",
                  verticalAlign: "bottom",
                };

                if (
                  watch(`hhdv_obj`) === undefined ||
                  watch(`hhdv_obj`)[index] === undefined
                ) {
                  return <React.Fragment key={index}></React.Fragment>;
                }
                return (
                  !isLoadTable && (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {arrayField.map(item => {
                        const itemField = listField[item];
                        let watchDisable = disableForm;
                        if (!watchDisable) {
                          if (fieldMain === HHDV_FIELD.HHDV_OBJ.field) {
                            switch (itemField.field) {
                              case HHDV_FIELD.HHDV_OBJ.list.TCHAT.field:
                              case HHDV_FIELD.HHDV_OBJ.list.THHDVU.field:
                                watchDisable = false;
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.THTIEN.field:
                                // watchDisable = true;
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2";
                                if (!watchDisable) {
                                  const sluong =
                                    watch(`hhdv_obj`)[index]["sluong"];
                                  const dgia = watch(`hhdv_obj`)[index]["dgia"];
                                  watchDisable =
                                    !isEmptyNumber(sluong) ||
                                    !isEmptyNumber(dgia);
                                }
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                              case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                              //   case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                              case HHDV_FIELD.HHDV_OBJ.list.DVTINH.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2";
                                break;
                              //   case HHDV_FIELD.HHDV_OBJ.list.TSUAT.field:
                              //     watchDisable =
                              //       watch(`hhdv_obj`)[index]["tchat"].value !==
                              //         "1" &&
                              //       watch(`hhdv_obj`)[index]["tchat"].value !==
                              //         "2" &&
                              //       watch(`hhdv_obj`)[index]["tchat"].value !==
                              //         "3";
                              //     break;
                              case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "3";
                                break;
                              //   case HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field:
                              //   case HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field:
                              //     watchDisable =
                              //       watch(`hhdv_obj`)[index]["tchat"].value !==
                              //       "3";
                              //     break;
                              default:
                                break;
                            }
                          } else {
                            watchDisable = true;
                          }
                        } else {
                          // Nếu điều chỉnh phiếu xuất kho tăng giảm thì chỉ cho chỉnh số lượng và đơn giá
                          if (
                            isTypeAdjustIncDesc &&
                            fieldMain === HHDV_FIELD.HHDV_OBJ.field
                          ) {
                            //   switch (itemField.field) {
                            //     //   case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                            //     case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                            //       if (
                            //         (watch(`hhdv_obj`)[index]["tchat"].value ===
                            //           "1" ||
                            //           watch(`hhdv_obj`)[index]["tchat"].value ===
                            //             "2") &&
                            //         isTypeAdjustIncDesc
                            //       )
                            //         watchDisable = false;
                            //       break;
                            //     default:
                            //       break;
                            //   }
                            switch (itemField.field) {
                              case HHDV_FIELD.HHDV_OBJ.list.TCHAT.field:
                              case HHDV_FIELD.HHDV_OBJ.list.THHDVU.field:
                                watchDisable = false;
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.THTIEN.field:
                                // watchDisable = true;
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2";
                                if (!watchDisable) {
                                  const sluong =
                                    watch(`hhdv_obj`)[index]["sluong"];
                                  const dgia = watch(`hhdv_obj`)[index]["dgia"];
                                  watchDisable =
                                    !isEmptyNumber(sluong) ||
                                    !isEmptyNumber(dgia);
                                }
                                break;
                              case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                              case HHDV_FIELD.HHDV_OBJ.list.DGIA.field:
                              //   case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                              case HHDV_FIELD.HHDV_OBJ.list.DVTINH.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2";
                                break;
                              //   case HHDV_FIELD.HHDV_OBJ.list.TSUAT.field:
                              //     watchDisable =
                              //       watch(`hhdv_obj`)[index]["tchat"].value !==
                              //         "1" &&
                              //       watch(`hhdv_obj`)[index]["tchat"].value !==
                              //         "2" &&
                              //       watch(`hhdv_obj`)[index]["tchat"].value !==
                              //         "3";
                              //     break;
                              case HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field:
                                watchDisable =
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "1" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "2" &&
                                  watch(`hhdv_obj`)[index]["tchat"].value !==
                                    "3";
                                break;
                              //   case HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field:
                              //   case HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field:
                              //     watchDisable =
                              //       watch(`hhdv_obj`)[index]["tchat"].value !==
                              //       "3";
                              //     break;
                              default:
                                break;
                            }
                          }
                          // Nếu điều chỉnh phiếu xuất kho thay đổi thông tin thì cho nhập hàng hóa
                          if (
                            isTypeAdjustChangeInfo &&
                            fieldMain === HHDV_FIELD.HHDV_OBJ.field
                          ) {
                            switch (itemField.field) {
                              //   case HHDV_FIELD.HHDV_OBJ.list.SLUONG.field:
                              case HHDV_FIELD.HHDV_OBJ.list.THHDVU.field:
                                watchDisable = false;
                                break;
                              default:
                                break;
                            }
                          }
                        }
                        let allowNegative = false;
                        // Disable field theo config
                        if (
                          fieldDisableConfig &&
                          fieldDisableConfig[itemField.field]
                        ) {
                          watchDisable = fieldDisableConfig[itemField.field];
                        }
                        switch (itemField.type) {
                          case "text":
                          case "number":
                            // điều chỉnh giảm thi  cho nhập đơn giá/số lượng âm
                            if (
                              (itemField.field === "sluong" ||
                                itemField.field === "dgia" ||
                                itemField.field === "ttoan_tsuat" ||
                                itemField.field === "ttoan_thtien" ||
                                itemField.field === "ttoan_tthue" ||
                                itemField.field === "thtien") &&
                              dataConfirmAction?.typeAdjust ===
                                TYPE_ADJUST_INVOICE.DECREASE
                            ) {
                              allowNegative = true;
                            }
                            let decimalScale = getDecimalScaleByUnitCurrency(
                              watch(`ttchung_dvtte`)?.value,
                              dataConfigInvoice?.decimal_place?.foreign_currency
                            );
                            if (itemField.field === "sluong") {
                              decimalScale = 2;
                            }
                            return (
                              <td
                                style={tdStyle}
                                key={item}
                                className="custom-form-table"
                              >
                                {generateInputFieldArray({
                                  label: t(`form.${itemField.field}`),
                                  isRequire: itemField.required,
                                  inputType: itemField.type,
                                  errors: errors,
                                  touched: touchedFields,
                                  fieldArray: fieldMain,
                                  index: index,
                                  fieldChild: itemField.field,
                                  placeholder: !itemField.disabled
                                    ? t("placeholder.enter", {
                                        title: t(`form.${itemField.field}`),
                                      })
                                    : "",
                                  register: register,
                                  disabled: watchDisable,
                                  setInputValueChange: setInputValueChange,
                                  control: control,
                                  isThousandSeparator:
                                    itemField.isThousandSeparator,
                                  allowNegative: allowNegative,
                                  optionGroup: OPTION_GROUP,
                                  onChangeHandle: caculateHHDV,
                                  onSelectSearch: dataSearch => {
                                    const dataChange = dataSearch || "";
                                    setInputProductSearch(dataChange);
                                  },
                                  extraComponent: {
                                    [EXTRA_BUTTON.ADD_PRODUCT]:
                                      buttonAddProduct(),
                                  },
                                  watch: watch,
                                  decimalScale: decimalScale,
                                })}
                              </td>
                            );
                          case "select":
                            return (
                              <td key={item} className="custom-form-table">
                                {generateSelectFieldArray({
                                  watch: watch,
                                  label: t(`form.${itemField.field}`),
                                  isRequire: itemField.required,
                                  errors: errors,
                                  fieldArray: fieldMain,
                                  index: index,
                                  fieldChild: itemField.field,
                                  placeholder: !itemField.disabled
                                    ? t("placeholder.select")
                                    : "",
                                  disabled: watchDisable,
                                  control: control,
                                  options: OPTION_GROUP[itemField.field],
                                  onChangeHandle: caculateHHDV,
                                  menuPlacementSetting: "bottom",
                                  allowCreate: itemField.allowCreate,
                                })}
                              </td>
                            );
                          case "date":
                            return (
                              <td key={item}>
                                <FormGroup className="mb-2">
                                  {generateDateField({
                                    labelFrom: t(`form.${itemField.field}`),
                                    isRequire: itemField.required,
                                    errors: errors,
                                    field: itemField.field,
                                    placeholder: "DD/MM/YYYY",
                                    disabled: itemField.disabled,
                                    control: control,
                                    options: optionDateLocale,
                                  })}
                                </FormGroup>
                              </td>
                            );
                          default:
                            break;
                        }
                      })}
                      {!isAuto && isEditableAdjustReplace && (
                        <td>
                          {!disableForm &&
                          !isTypeAdjustIncDesc &&
                          fieldsHHDV.length > 1 ? (
                            <React.Fragment>
                              <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                                {/* {fieldsArray.length > 1 && ( */}
                                <i
                                  title="Xóa bỏ"
                                  onClick={() => {
                                    removeFunc(index);
                                  }}
                                  className="mdi mdi-trash-can  text-danger font-size-18"
                                  style={{ cursor: "pointer" }}
                                />
                                {/* )} */}
                              </div>
                            </React.Fragment>
                          ) : !disableForm &&
                            dataConfirmAction?.typeAdjust ===
                              TYPE_ADJUST_INVOICE.DECREASE &&
                            fieldsHHDV.length > 1 ? (
                            <React.Fragment>
                              <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                                {/* {fieldsArray.length > 1 && ( */}
                                <i
                                  title="Xóa bỏ"
                                  onClick={() => {
                                    removeFunc(index);
                                  }}
                                  className="mdi mdi-trash-can  text-danger font-size-18"
                                  style={{ cursor: "pointer" }}
                                />
                                {/* )} */}
                              </div>
                            </React.Fragment>
                          ) : (
                            <React.Fragment></React.Fragment>
                          )}
                        </td>
                      )}
                    </tr>
                  )
                );
              })}
            </tbody>
          </Table>
        </div>
        <div
          className="mt-2 mb-2 d-flex"
          style={{ justifyContent: "space-between" }}
        >
          <div>
            <div>
              Tổng cộng: {fieldsHHDV.length}
              <div className="text-danger">
                * Vui lòng nhập ít nhất 1 dòng hợp lệ
              </div>
            </div>
          </div>
          <div className="d-flex gap-2">
            <ReactPaginate
              className="table-paginate"
              nextLabel=" >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={4}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              forcePage={currentPage}
              previousLabel="< "
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
            <select
              value={itemsPerPage}
              disabled={true}
              onChange={e => {
                setItemsPerPage(Number(e.target.value));
                setIsLoadTable(true);
                setIsChangeSizePage(true);
              }}
              style={{
                width: "fit-content",
                height: "37px",
              }}
            >
              {listSizePerPage.map(item => {
                return (
                  <option key={item} value={item}>
                    {item}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const generateTableSecond = (
    fieldContanst,
    listContanst,
    fieldsArray,
    removeFunc,
    addFunc,
    isAuto = false,
    styleTable = {}
  ) => {
    return (
      <div className="custom-table-border hhdv-table" style={{ ...styleTable }}>
        <Table className="table  table-bordered">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "20px" }}>
                STT
              </th>
              {Object.entries(listContanst)
                .filter(([k, v]) => !v.isHide && checkShowWithPageView(v))
                .map(([key, value]) => {
                  return (
                    <th
                      style={{ width: value.width }}
                      className="text-center"
                      key={key}
                    >
                      {t(`form.${value.field}`)}{" "}
                      {value.required && (
                        <span className="text-danger"> (*)</span>
                      )}
                    </th>
                  );
                })}
              {!isAuto && <th style={{ width: "20px" }}></th>}
            </tr>
          </thead>
          <tbody>
            {fieldsArray.map((field, index) => {
              const fieldMain = fieldContanst;
              const listField = listContanst;
              const arrayField = [];
              for (const key in listField) {
                if (
                  !listField[key].isHide &&
                  checkShowWithPageView(listField[key])
                ) {
                  arrayField.push(key);
                }
              }
              const tdStyle = {
                display: "table-cell",
                verticalAlign: "bottom",
              };
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  {arrayField.map(item => {
                    const itemField = listField[item];
                    let watchDisable = disableForm;
                    if (!watchDisable) {
                      watchDisable = true;
                    }
                    let allowNegative = true;
                    switch (itemField.type) {
                      case "text":
                      case "number":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateInputFieldArray({
                              label: t(`form.${itemField.field}`),
                              isRequire: itemField.required,
                              inputType: itemField.type,
                              errors: errors,
                              touched: touchedFields,
                              fieldArray: fieldMain,
                              index: index,
                              fieldChild: itemField.field,
                              placeholder: !itemField.disabled
                                ? t("placeholder.enter", {
                                    title: t(`form.${itemField.field}`),
                                  })
                                : "",
                              register: register,
                              disabled: watchDisable,
                              setInputValueChange: setInputValueChange,
                              control: control,
                              isThousandSeparator:
                                itemField.isThousandSeparator,
                              allowNegative: allowNegative,
                              watch: watch,
                            })}
                          </td>
                        );
                      case "select":
                        return (
                          <td key={item}>
                            {generateSelectFieldArray({
                              watch: watch,
                              label: t(`form.${itemField.field}`),
                              isRequire: itemField.required,
                              errors: errors,
                              fieldArray: fieldMain,
                              index: index,
                              fieldChild: itemField.field,
                              placeholder: !itemField.disabled
                                ? t("placeholder.select")
                                : "",
                              disabled: watchDisable,
                              control: control,
                              options: OPTION_GROUP[itemField.field],
                              onChangeHandle: caculateHHDV,
                              menuPlacementSetting: "top",
                              allowCreate: itemField.allowCreate,
                            })}
                          </td>
                        );
                      case "date":
                        return (
                          <td key={item}>
                            <FormGroup className="mb-2">
                              {generateDateField({
                                labelFrom: t(`form.${itemField.field}`),
                                isRequire: itemField.required,
                                errors: errors,
                                field: itemField.field,
                                placeholder: "DD/MM/YYYY",
                                disabled: itemField.disabled,
                                control: control,
                                options: optionDateLocale,
                              })}
                            </FormGroup>
                          </td>
                        );
                      default:
                        break;
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  const onChangeHandle = (data, field) => {
    switch (field) {
      case "send_mail":
        setInputCBSendMailChange(data);
        break;
      case "ttchung_dvtte":
        // autoSumGroupAll();
        break;
      case "nmua_mst":
        setInputMSTChange(data);
        if (data.length === 10 || data.length === 14) {
          setDisableBtnInfoByTax(true);
        }
        break;
      case "nmua_stknhang":
        if (data?.bank_name) {
          setValue("nmua_tnhang", data.bank_name, { shouldValidate: true });
        }
        break;
      case "nmua_mkhang":
        if (data) {
          for (const item in mapData) {
            const finalData = data[item];
            if (
              item === FIELD_CUSTOMER.STKNHANG ||
              item === FIELD_CUSTOMER.MA
            ) {
              setValue(
                mapData[item],
                {
                  value: finalData,
                  label: finalData,
                } || null,
                {
                  shouldValidate: true,
                }
              );
            } else {
              setValue(mapData[item], finalData || "", {
                shouldValidate: true,
              });
            }
          }
        }
        // if (data?.bank_name) {
        //   setValue("nmua_tnhang", data.bank_name, { shouldValidate: true });
        // }
        break;
      default:
        break;
    }
  };

  const setEnterpriseInfo = (info, listMapValue) => {
    for (const key in listMapValue) {
      const defaultValue = info[listMapValue[key]];
      if (defaultValue) {
        setValue(key, defaultValue, { shouldValidate: true });
      } else {
        setValue(key, "", { shouldValidate: true });
      }
    }
  };

  // Set info người mua theo MST
  const setInfoBuyerByTaxCode = () => {
    if (enterpriseByTaxCode?.enterpriseInfo) {
      const defaultEnterpriseInfo = {
        [ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN.field]: "companyNameVn",
        [ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field]: "registeredAddressVn",
        // [ISSUE_INVOICE_BUYER_FIELD.NMUA_SDTHOAI.field]: "phone",
        // [ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field]: "email",
      };
      setEnterpriseInfo(
        enterpriseByTaxCode.enterpriseInfo,
        defaultEnterpriseInfo
      );
    }
    if (enterpriseByTaxCode?.entRepResentative) {
      const defaultEnterpriseInfo = {
        [ISSUE_INVOICE_BUYER_FIELD.NMUA_HVTNNHANG.field]: "representativeName",
      };
      setEnterpriseInfo(
        enterpriseByTaxCode.entRepResentative,
        defaultEnterpriseInfo
      );
    }
  };

  // Button load thông tin theo MST
  const buttonLoadBuyerInfoByTax = () => {
    const disableBtn =
      disableBtnInfoByTax ||
      getValues("nmua_mst").length > 14 ||
      loadDingEnterpriseByTaxCode ||
      !enterpriseByTaxCode ||
      !enterpriseByTaxCode.enterpriseInfo;
    return (
      !disableForm && (
        <React.Fragment>
          {/* <button
            type="button"
            disabled={disableBtn}
            className={`btn btn-${disableBtn ? "warning" : "success"}`}
            onClick={() => {
              setInfoBuyerByTaxCode();
            }}
          > */}
          <button
            title={disableBtn ? "Chưa có thông tin" : "Load thông tin theo MST"}
            style={{
              width: "41px",
              height: "34px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "-9px",
            }}
            type="button"
            className={`btn btn-${disableBtn ? "warning" : "success"}`}
            onClick={() => {
              setInfoBuyerByTaxCode();
            }}
          >
            <i
              className={` ${
                loadDingEnterpriseByTaxCode
                  ? "bx bx-loader bx-spin"
                  : "fa fa-exclamation-circle"
              } font-size-16 align-middle`}
            ></i>
          </button>
          <div className="d-flex" style={{ width: "154px" }}>
            {/* </button> */}
            {isShowBtnAddCustomer && (
              <React.Fragment>
                <input
                  title="Lưu thông tin khách hàng để sử dụng lại"
                  type="checkbox"
                  id="checkbox_isSaveInfoCustomer"
                  className="custom-control-input checkbox-isSaveInfoCustomer"
                  style={{
                    minWidth: "30px",
                    height: "17px",
                    marginTop: "0px",
                  }}
                  {...register("isSaveInfoCustomer")}
                />
                <label
                  className="text-warning"
                  style={{
                    marginLeft: "2px",
                    marginTop: "-6px",
                  }}
                  htmlFor="checkbox_isSaveInfoCustomer"
                >
                  Lưu thông tin khách hàng
                </label>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      )
    );
  };

  // Button tìm khách hàng
  const buttonSeachCustomer = () => {
    return (
      !disableForm && (
        // <button
        //   type="button"
        //   style={{ width: "108px" }}
        //   className={`btn btn-primary`}
        //   onClick={() => {
        //     toggleSearchModal();
        //   }}
        // >
        <i
          title="Tìm kiếm"
          style={{ cursor: "pointer" }}
          onClick={() => {
            toggleSearchModal();
          }}
          className={`text-primary fas fa-search-plus font-size-16 align-middle me-2`}
        ></i>
        //   Tìm kiếm
        // </button>
      )
    );
  };

  // Button thêm tài khoản
  const buttonAddAccount = () => {
    return (
      !disableForm && (
        <button
          type="button"
          style={{
            height: "30px",
            width: "32px",
            background: "white",
            marginLeft: "7px",
          }}
          className={`btn btn-success d-flex align-items-center justify-content-center`}
          onClick={() => {
            toggleAddAccountBankModal();
          }}
        >
          <i
            title="Thêm tài khoản ngân hàng"
            style={{ cursor: "pointer" }}
            className={`text-success bx bx-plus-medical font-size-16 align-middle`}
          ></i>
        </button>
      )
    );
  };

  // Button thêm sản phẩm
  const buttonAddProduct = () => {
    return (
      <button
        type="button"
        style={{
          height: "30px",
          width: "32px",
          marginTop: "7px",
          background: "white",
          marginLeft: "2px",
          marginBottom: "8px",
          marginRight: "3px",
        }}
        className={`btn-add-product btn btn-success d-flex align-items-center justify-content-center`}
        title="Thêm sản phẩm mới"
        onClick={() => {
          toggleAddProductModal();
        }}
      >
        <i
          style={{ cursor: "pointer" }}
          className={`text-success bx bx-plus-medical font-size-16 align-middle`}
        ></i>
      </button>
    );
  };

  const getTitleModal = () => {
    let title = "";
    if (dataConfirmAction) {
      // Thay thế phiếu xuất kho
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Lập phiếu xuất kho thay thế";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          let typeAdjust = "";
          switch (dataConfirmAction.typeAdjust) {
            case TYPE_ADJUST_INVOICE.INCREASE:
              typeAdjust = "tăng";
              break;
            case TYPE_ADJUST_INVOICE.DECREASE:
              typeAdjust = "giảm";
              break;
            case TYPE_ADJUST_INVOICE.CHANGE_INFO:
              typeAdjust = "thay đổi thông tin";
              break;
            default:
              break;
          }
          title = "Lập phiếu xuất kho điều chỉnh " + typeAdjust;
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        // Tạo mới
        case issueInvoiceModeList.CREATE_WAREHOUSE_AGENCY_DETAIL:
          title = "Thêm mới phiếu xuất kho";
          break;
        // Cập nhật
        case issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL:
          title = "Cập nhật phiếu xuất kho";
          break;
        default:
          break;
      }
    }
    return title;
  };

  const getTextLinkOldInvoice = () => {
    let title = "";
    let id = null;
    if (dataConfirmAction) {
      const infoTT32 = dataConfirmAction.infoTT32;
      // Thay thế/ điều chỉnh phiếu xuất kho tt32
      if (infoTT32) {
        const today = new Date(infoTT32.tthdlquan_nlhdclquan);
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        switch (infoTT32.modeTT32) {
          case MODE_INVOICE_ACTION.REPLACE:
            title = `Thay thế cho phiếu xuất kho TT32 , Mẫu số: ${infoTT32.tthdlquan_khmshdclquan}, Ký hiệu: ${infoTT32.tthdlquan_khhdclquan}, Số: ${infoTT32.tthdlquan_shdclquan}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
            break;
          case MODE_INVOICE_ACTION.ADJUST:
            title = `Điều chỉnh cho phiếu xuất kho TT32 , Mẫu số: ${infoTT32.tthdlquan_khmshdclquan}, Ký hiệu: ${infoTT32.tthdlquan_khhdclquan}, Số: ${infoTT32.tthdlquan_shdclquan}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
            break;
          default:
            break;
        }
      } else {
        // Thay thế phiếu xuất kho
        const today = new Date(Number(dataConfirmAction.nlap) * 1000);
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();
        switch (dataConfirmAction.mode) {
          case MODE_INVOICE_ACTION.REPLACE:
            title = `Thay thế cho phiếu xuất kho Mẫu số: ${dataConfirmAction.pattern}, Ký hiệu: ${dataConfirmAction.serial}, Số: ${dataConfirmAction.invoiceNo}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
            break;
          case MODE_INVOICE_ACTION.ADJUST:
            title = `Điều chỉnh cho phiếu xuất kho Mẫu số: ${dataConfirmAction.pattern}, Ký hiệu: ${dataConfirmAction.serial}, Số: ${dataConfirmAction.invoiceNo}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
            break;
          default:
            break;
        }
        id = dataConfirmAction.id;
      }
    }
    //
    if (detailIssueInvoice?.root) {
      const today = new Date(detailIssueInvoice?.root.ttchung_nlap * 1000);
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      switch (detailIssueInvoice?.tthdlquan_tchdon) {
        case "1":
          title = `Thay thế cho phiếu xuất kho Mẫu số: ${detailIssueInvoice?.root.ttchung_khmshdon}, Ký hiệu: ${detailIssueInvoice?.root.ttchung_khhdon}, Số: ${detailIssueInvoice?.root.ttchung_shdon}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        case "2":
          title = `Điều chỉnh cho phiếu xuất kho Mẫu số: ${detailIssueInvoice?.root.ttchung_khmshdon}, Ký hiệu: ${detailIssueInvoice?.root.ttchung_khhdon}, Số: ${detailIssueInvoice?.root.ttchung_shdon}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        default:
          break;
      }
      id = detailIssueInvoice?.root.id;
    }
    // Thay thế cho phiếu xuất kho thông tư 32
    if (detailIssueInvoice?.tthdlquan_lhdclquan === "3") {
      const today = new Date(detailIssueInvoice?.tthdlquan_nlhdclquan * 1000);
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      switch (detailIssueInvoice?.tthdlquan_tchdon) {
        case "1":
          title = `Thay thế cho phiếu xuất kho TT32, Mẫu số: ${detailIssueInvoice?.tthdlquan_khmshdclquan}, Ký hiệu: ${detailIssueInvoice?.tthdlquan_khhdclquan}, Số: ${detailIssueInvoice?.tthdlquan_shdclquan}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        case "2":
          title = `Điều chỉnh cho phiếu xuất kho TT32, Mẫu số: ${detailIssueInvoice?.tthdlquan_khmshdclquan}, Ký hiệu: ${detailIssueInvoice?.tthdlquan_khhdclquan}, Số: ${detailIssueInvoice?.tthdlquan_shdclquan}, Ngày ${dd} tháng ${mm} năm ${yyyy}`;
          break;
        default:
          break;
      }
      id = null;
    }
    return (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (id) {
            showPdfById(id);
          }
        }}
        className="text-danger text-center font-size-20"
      >
        {title}
      </div>
    );
  };

  const getLabelButtonSubmit = () => {
    let title = "";
    if (dataConfirmAction) {
      // Thay thế /điều chỉnh phiếu xuất kho
      switch (dataConfirmAction.mode) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Lập phiếu xuất kho";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          title = "Lập phiếu xuất kho";
          break;
        default:
          break;
      }
      // Cập nhật phiếu xuất kho Thay thế /điều chỉnh ở trạng thái lưu tạm
      switch (dataConfirmAction.modeEdit) {
        case MODE_INVOICE_ACTION.REPLACE:
          title = "Cập nhật phiếu xuất kho";
          break;
        case MODE_INVOICE_ACTION.ADJUST:
          title = "Cập nhật phiếu xuất kho";
          break;
        default:
          break;
      }
    } else {
      switch (mode) {
        // Tạo mới
        case issueInvoiceModeList.CREATE_WAREHOUSE_AGENCY_DETAIL:
          title = "Lưu tạm";
          break;
        // Cập nhật
        case issueInvoiceModeList.EDIT_WAREHOUSE_AGENCY_DETAIL:
          title = "Cập nhật";
          break;
        default:
          break;
      }
    }
    return title;
  };

  const numberWithCommas = (x, isShow) => {
    let dau = "";
    if (isShow) {
      dau = x > 0 ? "+" : "";
    }
    return dau + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const isErrorAdjust = () => {
    // return (
    //   (getValues("ttoan_tgtttbso") -
    //     Number(detailIssueInvoice?.ttoan_tgtttbso) >=
    //     0 &&
    //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.DECREASE) ||
    //   (getValues("ttoan_tgtttbso") -
    //     Number(detailIssueInvoice?.ttoan_tgtttbso) <=
    //     0 &&
    //     dataConfirmAction?.typeAdjust === TYPE_ADJUST_INVOICE.INCREASE)
    // );
    return false;
  };

  //Check show/hide with page view
  const checkShowWithPageView = item => {
    if (item.isShowWithPageView && item.isShowWithPageView.length > 0) {
      if (item.isShowWithPageView.findIndex(item => item === pageView) === -1) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  };

  const mapData = {
    [FIELD_CUSTOMER.TEN]: ISSUE_INVOICE_BUYER_FIELD.NMUA_TEN.field,
    [FIELD_CUSTOMER.MST]: ISSUE_INVOICE_BUYER_FIELD.NMUA_MST.field,
    [FIELD_CUSTOMER.DCHI]: ISSUE_INVOICE_BUYER_FIELD.NMUA_DCHI.field,
    // [FIELD_CUSTOMER.MA]: ISSUE_INVOICE_BUYER_FIELD.NMUA_MKHANG.field,
    // [FIELD_CUSTOMER.SDTHOAI]: ISSUE_INVOICE_BUYER_FIELD.NMUA_SDTHOAI.field,
    // [FIELD_CUSTOMER.DCTDTU]: ISSUE_INVOICE_BUYER_FIELD.NMUA_DCTDTU.field,
    // [FIELD_CUSTOMER.STKNHANG]: ISSUE_INVOICE_BUYER_FIELD.NMUA_STKNHANG.field,
    // [FIELD_CUSTOMER.TNHANG]: ISSUE_INVOICE_BUYER_FIELD.NMUA_TNHANG.field,
  };
  const handleFiles = (files, uploadType = "") => {
    setListUploadFile([]);
    if (files.length > 0) {
      for (const item of files) {
        const bodyFormData = new FormData();
        bodyFormData.append("file", item);
        dispatch(uploadAttackFileInvoice(bodyFormData, uploadType));
      }
      if (modal && modal.current) {
        modal.current.scrollTop = modal.current.scrollHeight;
      }
    }
  };

  const generalFieldFirst = value => {
    let disableCheck = disableForm;
    // Nếu điều chỉnh thì cho nhập ngày lập
    if (isTypeAdjustChangeInfo || isTypeAdjustIncDesc) {
      switch (value.field) {
        case COMMON_FIELD.TTCHUNG_NLAP.field:
          disableCheck = false;
          break;
        default:
          break;
      }
    }
    return loopGenerateField({
      currentTime: currentTime?.data?.momentDate,
      item: value,
      label: t(`form.${value.field}`),
      placeholder: t("placeholder.enter", {
        title: t(`form.${value.field}`),
      }),
      errors,
      touchedFields,
      register,
      control,
      OPTION_GROUP,
      optionDateLocale,
      onChangeHandle,
      pageView,
      disableForm: disableCheck,
      typeAdjust: true,
      invoiceSymbolList: invoiceSymbolList,
      khhdonDefault: getKhhdDefault(),
      minDate: invoiceMaxDate?.data,
    });
  };

  const generalField = value => {
    let placeholder = "";
    if (value.field === "nmua_mst") {
      placeholder = "XXXXXXXXXX-XXX (Tối đa 14 kí tự)";
    } else {
      placeholder = t("placeholder.enter", {
        title: t(`form.${value.field}`),
      });
    }
    return loopGenerateField({
      currentTime: currentTime?.data?.momentDate,
      item: value,
      label: t(`form.${value.field}`),
      placeholder,
      errors,
      touchedFields,
      register,
      control,
      OPTION_GROUP,
      optionDateLocale,
      onChangeHandle,
      pageView,
      extraComponent: {
        [EXTRA_BUTTON.LOAD_TAX]: buttonLoadBuyerInfoByTax(),
        [EXTRA_BUTTON.SEARCH_CUSTOMER]: buttonSeachCustomer(),
        [EXTRA_BUTTON.ADD_ACCOUNT]: buttonAddAccount(),
      },
      disableForm,
      typeAdjust: dataConfirmAction?.typeAdjust,
      mode,
      listFieldCheckAdjust: SECOND_BLOCK.map(item => item.field),
    });
  };

  const exportProductExcel = async () => {
    const schema = [
      // Column #1
      {
        column: "STT",
        type: Number,
        value: product => product.stt,
      },
      // Column #2
      {
        column: "Mã sản phẩm",
        type: String,
        value: product => product.mhhdvu,
        width: 15,
      },
      // Column #3
      {
        column: "Hàng hóa",
        type: String,
        value: product => product.thhdvu,
        width: 15,
      },
      // Column #4
      {
        column: "Đơn vị tính",
        type: String,
        value: product => product.dvtinh,
        width: 15,
      },
      {
        column: "Số lượng",
        type: Number,
        value: product => product.sluong,
        width: 15,
      },
      {
        column: "Đơn giá",
        type: Number,
        value: product => product.dgia,
        width: 15,
      },
      {
        column: "Thành tiền",
        type: Number,
        value: product => product.thtien,
        width: 15,
      },
      //   {
      //     column: "Thuế suất",
      //     type: String,
      //     value: product => product.tsuat,
      //     width: 15,
      //   },
    ];
    let stt = 0;
    let listProduct = getValues(HHDV_FIELD.HHDV_OBJ.field);
    const objects = listProduct.map(item => {
      stt = stt + 1;
      //   let tsuat = item.tsuat.value + "%";
      //   if (item.tsuat.label === "KCT" || item.tsuat.label === "KKKNT") {
      //     tsuat = item.tsuat.label;
      //   }
      return {
        stt: stt,
        mhhdvu: String(item.mhhdvu),
        thhdvu: String(item.thhdvu),
        dvtinh: String(item.dvtinh),
        sluong: Number(item.sluong),
        dgia: Number(item.dgia),
        thtien: Number(item.thtien),
        // tsuat: String(tsuat),
      };
    });
    // // When passing `data` for each cell.
    await writeXlsxFile(objects, {
      schema, // optional
      fileName: "DanhSachSanPham.xlsx",
      headerStyle: {
        backgroundColor: "#eeeeee",
        fontWeight: "bold",
        align: "center",
      },
    });
  };

  const importHandle = data => {
    toggleImportProductModal();
    setIsLoadTable(true);
    setValue(ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.field, data);
    changeToPage(0);
  };

  const defaultDataAdjustChangeInfo = () => {
    appendHHDV({
      [HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]: OPTION_HHDV_TCHAT[3],
      [HHDV_FIELD.HHDV_OBJ.list.STT.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.DVTINH.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.SLUONG.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.DGIA.field]: "",
      //   [HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field]: "",
      //   [HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field]: "",
      [HHDV_FIELD.HHDV_OBJ.list.THTIEN.field]: "",
      //   [HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: {
      //     value: "",
      //     label: "",
      //   },
      [HHDV_FIELD.HHDV_OBJ.list.TTKHAC.field]: "",
    });
  };

  return (
    <React.Fragment>
      <UploadProductExcelModal
        isOpen={modalImportProduct}
        listVat={listVat}
        OPTION_HHDV_TCHAT={OPTION_HHDV_TCHAT}
        toggle={toggleImportProductModal}
        importHandle={importHandle}
      ></UploadProductExcelModal>
      <CreateAccountBankModal
        dataDetail={null}
        isOpenModal={modalAccountBank}
        toggleModal={toggleAddAccountBankModal}
        mode={modeDetail.CREATE}
      />
      <DetailDataProduct
        dataDetail={null}
        listVat={listVat}
        isOpenModal={modalProduct}
        toggleModal={toggleAddProductModal}
        mode={modeDetail.CREATE}
      />
      <SearchCustomerModal
        mapData={mapData}
        setValueFunc={setValue}
        isOpen={modalSearch}
        toggle={toggleSearchModal}
        listAllCustomer={listAllCustomer || []}
      ></SearchCustomerModal>
      <Modal
        isOpen={isOpenModal}
        toggle={() => {
          toggleModal("", isPage);
        }}
        size="xl"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        contentClassName="detail-data-format"
        style={{ maxWidth: "98%" }}
      >
        {/* {pageView}
        {mode}
        {JSON.stringify(dataConfirmAction)}
        {typeInvoiceAnother}
        {isTypeAdjustChangeInfo ? " isChangeInfo " : " isNotChangeInfo "}
        {disableForm ? " isdisableForm" : " isNotdisableForm"} */}
        {/* <ModalHeader toggle={toggleModal}> */}
        {/* {getTitleModal()}
          {pageView} */}
        {/* </ModalHeader> */}
        {isLoadingConfigField || loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                onKeyDown={e => {
                  if (
                    e.code === "F2" &&
                    isOpenModal &&
                    !disableForm &&
                    isEditableAdjustReplace
                  ) {
                    addNewRowHHDVHandle();
                  }
                }}
                tabIndex="0"
                style={{
                  maxHeight: "83vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div>{getTextLinkOldInvoice()}</div>

                {/* <div
                  className="custom-form-heading"
                  style={{ paddingTop: "0px" }}
                >
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN CHUNG</strong>
                </div> */}

                <Row className="row-cols-1">
                  {Object.entries(
                    customViewField([
                      FIRST_BLOCK[0],
                      FIRST_BLOCK[1],
                      FIRST_BLOCK[2],
                    ])
                  ).map(([key, value]) => {
                    return generalFieldFirst(value);
                  })}
                </Row>
                <Row className="row-cols-1">
                  {Object.entries(
                    customViewField([
                      FIRST_BLOCK[3],
                      FIRST_BLOCK[4],
                      FIRST_BLOCK[5],
                    ])
                  ).map(([key, value]) => {
                    return generalFieldFirst(value);
                  })}
                </Row>
                {/* <Row className="row-cols-1">
                  {Object.entries(customViewField([FIRST_BLOCK[6]])).map(
                    ([key, value]) => {
                      return generalFieldFirst(value);
                    }
                  )}
                </Row> */}
                {/* <div className="custom-form-heading mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN NGƯỜI BÁN</strong>
                </div> */}
                <Card
                  style={{
                    border: "1px solid #d4d4d4",
                    zIndex: "3",
                  }}
                >
                  <CardBody>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[0],
                          SECOND_BLOCK[1],
                          SECOND_BLOCK[2],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[3],
                          SECOND_BLOCK[4],
                          SECOND_BLOCK[5],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[6],
                          SECOND_BLOCK[7],
                          SECOND_BLOCK[8],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(
                        customViewField([
                          SECOND_BLOCK[9],
                          SECOND_BLOCK[10],
                          SECOND_BLOCK[11],
                        ])
                      ).map(([key, value]) => {
                        return generalField(value);
                      })}
                    </Row>
                    <Row className="row-cols-1 row-cols-md-3">
                      {Object.entries(customViewField([SECOND_BLOCK[12]])).map(
                        ([key, value]) => {
                          return generalField(value);
                        }
                      )}
                    </Row>
                  </CardBody>
                </Card>

                {/* <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN NGƯỜI MUA</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-3">
                  {Object.entries(ISSUE_INVOICE_BUYER_FIELD).map(
                    ([key, value]) => {
                      let placeholder = "";
                      if (value.field === "nmua_mst") {
                        placeholder = "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)";
                      } else {
                        placeholder = t("placeholder.enter", {
                          title: t(`form.${value.field}`),
                        });
                      }
                      return loopGenerateField(
                        value,
                        t(`form.${value.field}`),
                        placeholder,
                        errors,
                        touchedFields,
                        register,
                        control,
                        OPTION_GROUP,
                        optionDateLocale,
                        "",
                        onChangeHandle,
                        "",
                        {
                          [EXTRA_BUTTON.LOAD_TAX]: buttonLoadBuyerInfoByTax(),
                          [EXTRA_BUTTON.SEARCH_CUSTOMER]: buttonSeachCustomer(),
                        },
                        disableForm,
                        dataConfirmAction?.typeAdjust !==
                          TYPE_ADJUST_INVOICE.CHANGE_INFO
                      );
                    }
                  )}
                </Row> */}
                {/* <div className="custom-form-heading  mt-1">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong>THÔNG TIN DANH SÁCH HDDV</strong>
                </div> */}
                <div
                  className="mb-2 d-flex"
                  style={{ justifyContent: "space-between" }}
                >
                  <div
                    style={{
                      fontStyle: "italic",
                      paddingTop: "20px",
                    }}
                  >
                    <div style={{ color: "#36a3f7" }}>
                      F2: thêm dòng, Enter: xuống dòng
                    </div>
                  </div>
                  <React.Fragment>
                    <div className="d-flex align-items-center">
                      <Button
                        className="me-2 d-flex gap-1"
                        color="info"
                        outline
                        onClick={() => {
                          exportProductExcel();
                        }}
                      >
                        <i
                          className="far fa-file-excel label-icon"
                          style={{ fontSize: "17px" }}
                        ></i>
                        Xuất file
                      </Button>
                      {!disableForm && !isTypeAdjustIncDesc && (
                        <Button
                          className="me-2 d-flex gap-1"
                          color="info"
                          outline
                          onClick={() => {
                            toggleImportProductModal();
                          }}
                        >
                          <i
                            className="far fa-file-excel label-icon"
                            style={{ fontSize: "17px" }}
                          ></i>
                          Nhập file
                        </Button>
                      )}
                    </div>
                  </React.Fragment>
                </div>
                {isOpenModal &&
                  generateTable(
                    HHDV_FIELD.HHDV_OBJ.field,
                    HHDV_FIELD.HHDV_OBJ.list,
                    currentItemsHHDV,
                    removeNewRowHHDVHandle,
                    addNewRowHHDVHandle
                  )}
                <div
                  className="d-flex"
                  style={{ alignItems: "end", flexDirection: "column" }}
                >
                  {/* {Object.entries(ISSUE_INVOICE_PAYMENT_FIELD).map(
                    ([key, item]) => {
                      let disable = disableForm;
                      if (
                        item.field === "ttoan_tgtttbchu" &&
                        isTypeAdjustIncDesc
                      ) {
                        disable = false;
                      }
                      return loopGenerateField(
                        item,
                        t(`form.${item.field}`),
                        t("placeholder.enter", {
                          title: t(`form.${item.field}`),
                        }),
                        errors,
                        touchedFields,
                        register,
                        control,
                        OPTION_GROUP,
                        optionDateLocale,
                        "custom-form",
                        null,
                        pageView,
                        null,
                        disable
                      );
                    }
                  )} */}
                </div>
                {dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
                dataConfirmAction?.mode === MODE_INVOICE_ACTION.ADJUST ||
                listHaveUploadFile.length > 0 ? (
                  <React.Fragment>
                    <div className="custom-form-heading  mt-1">
                      <i className="fas fa-paperclip text-primary"></i>
                      <strong>BIÊN BẢN ĐÍNH KÈM</strong>
                    </div>
                    {(dataConfirmAction?.mode === MODE_INVOICE_ACTION.REPLACE ||
                      dataConfirmAction?.mode ===
                        MODE_INVOICE_ACTION.ADJUST) && (
                      <Row>
                        <Col>
                          <UploadForm
                            multiple={true}
                            handleFiles={files => handleFiles(files)}
                            accept=".doc,.docx,.pdf"
                            removeFile={(a, index) => {
                              listUploadFile.splice(index, 1);
                              setListUploadFile(listUploadFile);
                            }}
                          ></UploadForm>
                        </Col>
                      </Row>
                    )}
                    {listHaveUploadFile.length > 0 &&
                      dataConfirmAction?.mode !== MODE_INVOICE_ACTION.REPLACE &&
                      dataConfirmAction?.mode !==
                        MODE_INVOICE_ACTION.ADJUST && (
                        <React.Fragment>
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {listHaveUploadFile.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row
                                      className="align-items-center"
                                      onClick={() => {
                                        dispatch(
                                          downloadXmlIssueInvoice(
                                            f.id,
                                            f.file_name,
                                            "blob",
                                            null,
                                            "." + f.file_type
                                          )
                                        );
                                      }}
                                    >
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold align-items-center font-size-18 d-flex gap-2"
                                        >
                                          <i
                                            className={`${getIconFile(
                                              f.file_type
                                            )} label-icon`}
                                          ></i>
                                          {f.file_name + "." + f.file_type}
                                        </Link>
                                        {/* <p className="mb-0">
                                    <strong>{f.formattedSize}</strong>
                                  </p> */}
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              );
                            })}
                          </div>
                        </React.Fragment>
                      )}
                  </React.Fragment>
                ) : (
                  <React.Fragment></React.Fragment>
                )}
              </div>
            </ModalBody>
            <ModalFooter>
              {mode !== issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL && (
                <Button
                  color="primary"
                  className="btn-label"
                  type="button"
                  onClick={() => {
                    handleSubmit(onSubmit, beforeSubmit)();
                  }}
                  disabled={
                    loadingCreate ||
                    loadingEdit ||
                    loadingUploadFile ||
                    isErrorAdjust()
                  }
                >
                  <i className="bx bx-save label-icon"></i>
                  {getLabelButtonSubmit()}
                </Button>
              )}
              {/* <Button color="success" className="btn-label" type="button">
                <i className="bx bx-save label-icon"></i>
                Ký
              </Button> */}
              {/* {btnShowFooter?.btnRelease?.isShow && (
                <Button color="success" className="btn-label" type="button">
                  <i className="bx bx-send font-size-18 label-icon"></i>
                  Phát hành & Kí số
                </Button>
              )} */}
              {/* Cần cấp duyệt */}
              {(detailIssueInvoice?.auth_status === AUTH_STATUS_NEW ||
                detailIssueInvoice?.auth_status === AUTH_STATUS_RR) &&
                detailIssueInvoice?.approve_status === APPROVE_STATUS_A &&
                finalBuInfo?.need_approve === 1 &&
                isRoleAccountant &&
                detailIssueInvoice?.auto_sign === 0 &&
                detailIssueInvoice?.source !== SOURCE_QUEUE.QUEUE_MSEAG && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onRelease, beforeRelease)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Phát hành & Kí số HSM
                  </Button>
                )}
              {/* Cần cấp duyệt */}
              {(detailIssueInvoice?.auth_status === AUTH_STATUS_NEW ||
                detailIssueInvoice?.auth_status === AUTH_STATUS_RR) &&
                finalBuInfo?.need_approve === 1 &&
                detailIssueInvoice?.auto_sign === 0 &&
                detailIssueInvoice?.source === SOURCE_QUEUE.QUEUE_MSEAG && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onRelease, beforeRelease)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Phát hành & Kí số HSM
                  </Button>
                )}
              {/* Không cần cấp duyệt */}
              {(detailIssueInvoice?.auth_status === AUTH_STATUS_NEW ||
                detailIssueInvoice?.auth_status === AUTH_STATUS_RR) &&
                finalBuInfo?.need_approve === 0 && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onRelease, beforeRelease)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Phát hành & Kí số HSM
                  </Button>
                )}
              {btnShowFooter?.btnSubmit?.isShow && (
                <Button
                  color="success"
                  className="btn-label"
                  type="button"
                  disabled={
                    loadingCreate ||
                    loadingEdit ||
                    loadingUploadFile ||
                    isErrorAdjust()
                  }
                  onClick={() => {
                    handleSubmit(onSentApprove, beforeSendApprove)();
                  }}
                >
                  <i className="bx bx-send font-size-18 label-icon"></i>
                  Gửi duyệt phiếu xuất kho
                </Button>
              )}
              {btnShowFooter?.btnSubmitEdit?.isShow &&
                (checkVisibleByConditionRowData(
                  btnShowFooter?.btnSubmitEdit?.listConditionRow[0],
                  detailIssueInvoice
                ) ||
                  checkVisibleByConditionRowData(
                    btnShowFooter?.btnSubmitEdit?.listConditionRow[1],
                    detailIssueInvoice
                  )) &&
                ((!dataConfirmAction &&
                  detailIssueInvoice?.approve_status === APPROVE_STATUS_M) ||
                  dataConfirmAction) && (
                  <Button
                    color="success"
                    className="btn-label"
                    disabled={
                      loadingCreate ||
                      loadingEdit ||
                      loadingUploadFile ||
                      isErrorAdjust()
                    }
                    type="button"
                    onClick={() => {
                      handleSubmit(onSentApprove, beforeSendApprove)();
                    }}
                  >
                    <i className="bx bx-send font-size-18 label-icon"></i>
                    Gửi duyệt phiếu xuất kho
                  </Button>
                )}
              {/* <Button color="warning" className="btn-label" type="button">
                <i className="bx bxs-file-pdf label-icon"></i>
                Xem trước
              </Button> */}
              {mode === issueInvoiceModeList.VIEW_WAREHOUSE_AGENCY_DETAIL && (
                <React.Fragment>
                  {/* <Button
                    type="button"
                    color="primary"
                    className="btn-label"
                    onClick={() => {
                      let resource_id = null;
                      let type = "";
                      if (detailIssueInvoice?.auth_status === AUTH_STATUS_NEW) {
                        type = "raw";
                      } else {
                        type = "signed";
                      }
                      resource_id = getResourceIdXML(
                        detailIssueInvoice.resource_list,
                        type
                      );
                      dispatch(
                        downloadXmlIssueInvoice(
                          resource_id,
                          detailIssueInvoice?.ttchung_thdon,
                          "blob",
                          typeInvoiceAnother
                        )
                      );
                    }}
                  >
                    <i className="bx bx-download label-icon"></i>
                    Download XML
                  </Button> */}
                  {/* <Button
                    type="button"
                    color="danger"
                    className="btn-label"
                    onClick={() => {
                      //   dispatch(
                      //     downloadXmlIssueInvoice(
                      //       detailRegistryInvoices?.resource_id,
                      //       detailRegistryInvoices?.ttchung_thdon
                      //     )
                      //   );
                    }}
                  >
                    <i className="bx bxs-file-pdf label-icon"></i>
                    Download PDF
                  </Button> */}
                </React.Fragment>
              )}
              <Button
                type="button"
                color="danger"
                className="me-2 btn-label"
                onClick={() => {
                  toggleModal("", isPage);
                }}
              >
                <i className="bx bx-x label-icon" />
                Đóng
              </Button>
            </ModalFooter>
          </React.Fragment>
        )}
      </Modal>
    </React.Fragment>
  );
});

DetailData.propTypes = {
  btnShowFooter: PropTypes.any,
  isOpenModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  showPdfById: PropTypes.func,
  dataDetail: PropTypes.object,
  dataConfirmAction: PropTypes.any,
  mode: PropTypes.string,
  typeInvoiceAnother: PropTypes.string,
  khhdonDefault: PropTypes.string,
  pageView: PropTypes.string,
  invoiceSymbolList: PropTypes.array,
  setDataInvoiceTemp: PropTypes.any,
  isEnterprise: PropTypes.any,
  isPage: PropTypes.bool,
  setDataConfirmAction: PropTypes.func,
  setPageViewByRow: PropTypes.func,
  setMode: PropTypes.func,
  isRoleStore: PropTypes.any,
  isRoleAccountant: PropTypes.any,
  setTitleBodyDenyRelease: PropTypes.any,
  toggleDenyReleaseModal: PropTypes.any,
  setTitleBodyCheckRelease: PropTypes.any,
  toggleCheckReleaseModal: PropTypes.any,
};

DetailData.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  pageView: "",
  invoiceSymbolList: [],
  isPage: false,
  isRoleStore: false,
  isRoleAccountant: false,
};

export default DetailData;
